// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:34.201Z
// Property: Cottages at Tallgrass Point (ID: 6767906449167039)
// Collections: 31 amenities, 6 floorplans (live), 48 photos, 72 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167039",
  "property_external_id": "478202",
  "property_zillow_url": "https://www.zillow.com/apartments/owasso-ok/cottages-at-tallgrass-point/CgzmCx/",
  "property_apartments_url": "https://www.apartments.com/cottages-at-tallgrass-point-owasso-ok/w8sgfwj/",
  "property_google_business_url": "https://www.google.com/maps/place/Cottages+at+Tallgrass+Point+Apartments/data=!4m2!3m1!1s0x0:0xff3ed12d088d8f25?sa=X&ved=2ahUKEwi2hZf8g4OTAxUf1fACHduDEAYQ_BJ6BAgKEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cottages-at-tallgrass-point",
  "property_name": "Cottages at Tallgrass Point",
  "property_website_url": "https://www.caseusa.com/apartments/ok/owasso/cottages-at-tallgrass-point/",
  "property_domain": null,
  "property_address": "8748 North Mingo Road",
  "property_full_address": "8748 N Mingo Rd, Owasso, OK 74055",
  "property_address_1": "8748 N Mingo Rd",
  "property_address_2": null,
  "property_address_city": "Owasso",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74055",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "North Tulsa",
  "property_address_latitude": "36.2798297",
  "property_address_longitude": "-95.86697579999999",
  "property_email": "tallgrass@caseusa.com",
  "property_phone": "(539) 224-5633",
  "property_call_tracking_phone": "855-738-0146",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Cottages at Tallgrass Point, where modern living meets comfort in Owasso, OK. Our beautifully designed one- and two-bedroom apartments feature gourmet kitchens, cozy fireplaces, and private patios. Enjoy resort-style amenities like a zero-entry pool, outdoor lounges, and a pet-friendly environment. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Cottages at Tallgrass Point Apartments is a spectacular, new community Now Leasing Owasso, OK Our amenities are designed with your comfort and convenience in mind and include a gourmet kitchen, washer and dryer connections, large walk-in closets and - in select units - a cozy fireplace for those chilly winter days. Stroll through our tranquil grounds or lounge next to our resort-style pool with sundeck and then enjoy lunch in our picnic area, which includes built-in barbecue grills. Or, get your heart rate up at our 24-hour fitness center. The Cottages at Tallgrass is a pet-friendly community with our on-site Bark Park that's sure to provide plenty of fun and exercise for your four-legged friend. Feel like exploring your new neighborhood? We're conveniently located within minutes of some of Owasso's best shopping and dining including Starplex Cinemas, Walmart, Target, SAM's, Hobby Lobby and more. We offer convenient access to Highway 169 and US 75 making it easy to get to Owasso & T",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fb452-9ce8-72cc-ae26-43254ed61101.webp",
  "property_featured_image_media": {
    "alt_text": "The Cottages at Tallgrass Point monument sign and exterior buildings.",
    "public_id": "019fb452-9ce8-72cc-ae26-43254ed61101",
    "storage_key": "property/6767906449167039/019fb452-9ce8-72cc-ae26-43254ed61101.webp",
    "width": 984,
    "height": 656
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "266",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": "12",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.74436090225564",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets allowed (cats and dogs). Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed (cats and dogs). Breed restrictions apply. Pet rent: $30 per pet per month. One-time non-refundable fee: $500 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cottagesattallgrassapartmentsowasso.securecafe.com/onlineleasing/cottages-at-tallgrass-point/floorplans.aspx",
  "property_resident_portal_url": "https://cottagesattallgrassapartmentsowasso.securecafe.com/residentservices/cottages-at-tallgrass-point/userlogin.aspx",
  "property_apply_now_url": "https://cottagesattallgrassapartmentsowasso.securecafe.com/onlineleasing/cottages-at-tallgrass-point/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-10ac-736f-ac0d-e4381ff1f26a.webp",
  "property_primary_logo_media": {
    "alt_text": "The Cottages At Tallgrass Point logo",
    "public_id": "019cfb51-10ac-736f-ac0d-e4381ff1f26a",
    "storage_key": "property/6767906449167039/019cfb51-10ac-736f-ac0d-e4381ff1f26a.webp",
    "width": 1800,
    "height": 960
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-10ac-736f-ac0d-e4381ff1f26a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Cottages At Tallgrass Point logo",
    "public_id": "019cfb51-10ac-736f-ac0d-e4381ff1f26a",
    "storage_key": "property/6767906449167039/019cfb51-10ac-736f-ac0d-e4381ff1f26a.webp",
    "width": 1800,
    "height": 960
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb52-f062-7008-b298-e4ad8f5d7934.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Cottages at Tallgrass Point logo",
    "public_id": "019cfb52-f062-7008-b298-e4ad8f5d7934",
    "storage_key": "property/6767906449167039/019cfb52-f062-7008-b298-e4ad8f5d7934.webp",
    "width": 640,
    "height": 341
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#cac4b8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1267",
  "property_sqft_min": "789",
  "property_sqft_max": "1,267",
  "property_price_range": "1134 - 1684",
  "property_price_min": "1134",
  "property_price_max": "1684",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/TheVillasAtBaileyRanch/",
  "property_instagram_url": "https://www.instagram.com/cottagesattallgrass/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFeaSQmXwtocRJY-NCC3RPv8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Catoosa%2C+OK",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cottages at Tallgrass Point",
  "property_home_romance_title": "Love Where You Live: Your New Apartment Awaits",
  "property_home_amenities_blurb": "Welcome to Cottages at Tallgrass Point in Owasso, OK, where modern living meets serene comfort. Choose from our thoughtfully designed one and two-bedroom apartments, complete with stylish finishes and a private patio. Enjoy exceptional amenities like a resort-style pool, outdoor lounges, and an onsite dog park—your new home awaits!",
  "property_home_floorplans_blurb": "At Cottages at Tallgrass Point in Owasso, OK, each floor plan is designed with your comfort in mind. Embrace a lifestyle of tranquility and modern living in our thoughtfully crafted apartments. Browse our available homes today to find the layout that perfectly matches your needs and aspirations.",
  "property_home_gallery_blurb": "At Cottages at Tallgrass Point in Owasso, indulge in a harmonious blend of comfort and style. Choose from spacious one- or two-bedroom layouts, and unwind at our resort-style pool or elegant outdoor spaces. With amenities like an onsite dog park and 24-hour fitness center, picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Cottages at Tallgrass Point, where vibrant living meets a rich tapestry of local attractions. Nestled in Owasso, OK, you’ll find the Tulsa Zoo, Mohawk Park, and Airtopia Adventure Park just moments away. Embrace a lifestyle surrounded by nature, adventure, and community comfort, all at your doorstep!",
  "property_home_reviews_blurb": "At Cottages at Tallgrass Point in Owasso, OK, residents rave about the vibrant community atmosphere, saying, “Living here feels like being part of a family.” Experience the warmth and connection that makes our apartments more than just a place to live. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Cottages at Tallgrass Point in Owasso, OK, vibrant living meets endless adventure. Discover parks, museums, and attractions like the Tulsa Zoo and Airtopia Adventure Park, all just moments away. From nature enthusiasts to thrill-seekers, this community offers a rich tapestry of nearby gems for your lifestyle. Explore your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cottages at Tallgrass Point in Owasso, OK, luxury meets comfort. Enjoy modern one- and two-bedroom floor plans with elegant finishes, a resort-style pool, and an inviting outdoor kitchen. Unleash your furry friends in our dog park or unwind by the fire pit—life here is both vibrant and effortless!",
  "property_applynow_blurb": "At Cottages at Tallgrass Point in Owasso, OK, modern living meets comfort. Choose from stylish one or two-bedroom apartments featuring gourmet kitchens, cozy fireplaces, and private patios. Unwind at our resort-style pool or in the dog park, and enjoy exclusive amenities designed for your lifestyle. Lease online today!",
  "property_contactus_blurb": "At Cottages at Tallgrass Point in Owasso, OK, our thoughtfully designed floor plans include one and two-bedroom options tailored to your lifestyle. Whether you seek cozy comfort or spacious living, our community is ready to welcome you home. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "Located in the heart of Owasso, OK, Cottages at Tallgrass Point offers thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page provides all the answers you need for a seamless living experience in our vibrant community. Dive in and learn more today!",
  "property_floorplans_blurb": "At Cottages at Tallgrass Point in Owasso, OK, our thoughtfully designed floor plans cater to your lifestyle. Choose from cozy one-bedroom retreats or spacious two-bedroom havens. Each home is crafted for comfort and convenience. Browse our available apartment homes today to uncover the perfect fit for your needs!",
  "property_gallery_blurb": "At Cottages at Tallgrass Point in Owasso, OK, picture yourself enjoying the luxury of spacious one and two-bedroom floor plans. Revel in community amenities such as a zero-entry resort-style pool, outdoor entertainment spaces, and an onsite dog park—all designed with your comfort in mind. Welcome home!",
  "property_interactivemap_blurb": "At Cottages at Tallgrass Point in Owasso, OK, luxury meets comfort with unique one- and two-bedroom floor plans designed for modern living. Enjoy resort-style amenities like our zero-entry pool, outdoor kitchen, and pet-friendly spaces. Navigate your ideal apartment effortlessly with our interactive community map—your new home awaits!",
  "property_pets_blurb": "At Cottages at Tallgrass Point in Owasso, OK, your furry companions are part of the family. With no weight limit for up to two pets, embrace a lifestyle where your dogs and cats can happily call this vibrant community home. Join us for comfort, luxury, and pet-friendly living!",
  "property_referafriend_blurb": "At Cottages at Tallgrass Point in Owasso, OK, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Great friends make great neighbors — invite a friend to join our vibrant community today and enjoy the comforts of modern living together!",
  "property_residentaccess_blurb": "Welcome to Cottages at Tallgrass Point in Owasso, OK, where comfort meets convenience. Choose from our thoughtfully designed one- and two-bedroom floor plans. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy all the benefits of community living today! Your cozy retreat awaits.",
  "property_reviews_blurb": "At Cottages at Tallgrass Point in Owasso, OK, residents rave, \"The sense of community here is unmatched!\" Experience exceptional living where neighbors become friends and every day feels like a retreat. Dive into heartfelt testimonials and see what our residents have to say about living at our vibrant community!",
  "property_created_at": "1770656467618",
  "property_scheduletour_blurb": "At Cottages at Tallgrass Point in Owasso, OK, our thoughtfully designed one and two-bedroom apartments cater to your lifestyle. With spacious floor plans and vibrant community living, you’ll feel right at home. Schedule a tour today and see what our residents are raving about—your perfect retreat awaits!",
  "property_thankyou_blurb": "Thank you for your interest in Cottages at Tallgrass Point in Owasso, OK! With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. Stay tuned—our team will be in touch soon to guide you towards your new home!",
  "property_virtualtours_blurb": "At Cottages at Tallgrass Point in Owasso, OK, choose from stylish one and two-bedroom floor plans tailored to your lifestyle. Imagine relaxing in your new home surrounded by beautiful grounds. Embrace the experience with a virtual tour of our apartments for rent; your next adventure awaits!",
  "property_copyright": "2026 All Rights Reserved. Cottages at Tallgrass Point",
  "property_seo_title_home": "Cottages at Tallgrass Point |  Apartments in Owasso, OK",
  "property_seo_description_home": "Find your perfect haven at Cottages at Tallgrass Point! Enjoy resort-style amenities, modern designs, and a pet-friendly community in Owasso, OK.",
  "property_seo_title_floorplans": "Floor Plans | Owasso, OK Apartments for Rent",
  "property_seo_description_floorplans": "Unwind at Cottages at Tallgrass Point in Owasso, OK. Browse unique one and two-bedroom floor plans to find your ideal apartment home today!",
  "property_seo_title_amenities": "Amenities | Owasso, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Cottages at Tallgrass Point! Enjoy resort-style amenities, spacious floor plans, and a pet-friendly lifestyle in Owasso, OK.",
  "property_seo_title_gallery": "Gallery | Apartments in Owasso, OK",
  "property_seo_description_gallery": "Experience luxury living at Cottages at Tallgrass Point, Owasso, OK—pet-friendly, stunning floor plans, and amazing amenities await!",
  "property_seo_title_virtualtours": "Virtual Tours | Cottages at Tallgrass Point Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Cottages at Tallgrass Point in Owasso, OK! Take a virtual tour of our inviting one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Cottages at Tallgrass Point Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at Cottages at Tallgrass Point, Owasso! Enjoy modern amenities, pet-friendly spaces, and a resort-style pool!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Owasso, OK",
  "property_seo_description_neighborhood": "Uncover the charm of Owasso, OK at Cottages at Tallgrass Point. Dive into local favorites and attractions nearby—your new neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Cottages at Tallgrass Point",
  "property_seo_description_contact": "Connect with our leasing team at Cottages at Tallgrass Point in Owasso, OK! Enjoy spacious one and two-bedroom floor plans. We're here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Owasso, OK",
  "property_seo_description_faqs": "Have questions about Cottages at Tallgrass Point in Owasso? Our FAQs cover community features, amenities, and more to help you find your perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Owasso, OK",
  "property_seo_description_reviews": "Experience the charm of Cottages at Tallgrass Point in Owasso, OK. See why residents love our amenities, stunning floor plans, and welcoming community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Owasso, OK",
  "property_seo_description_applynow": "Discover modern living at Cottages at Tallgrass Point in Owasso, OK! Enjoy luxury amenities and pet-friendly options. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Cottages at Tallgrass Point",
  "property_seo_description_residentaccess": "Join the Cottages at Tallgrass Point community in Owasso! Log in to your resident portal for easy rent payment, maintenance requests, and exclusive updates.",
  "property_seo_title_referafriend": "Refer A Friend | Cottages at Tallgrass Point",
  "property_seo_description_referafriend": "Refer a friend to Cottages at Tallgrass Point in Owasso, OK, and enjoy vibrant living together! Great friends make the best neighbors—share the love!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cottages at Tallgrass Point",
  "property_seo_description_scheduletour": "Experience the charm of Cottages at Tallgrass Point in Owasso, OK. Schedule your tour today and find your perfect home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Cottages at Tallgrass Point",
  "property_seo_description_privacy": "Safeguarding your journey at Cottages at Tallgrass Point in Owasso, OK. Learn how we protect your privacy while you enjoy our community. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Cottages at Tallgrass Point",
  "property_seo_description_accessibility": "At Cottages at Tallgrass Point in Owasso, OK, we prioritize digital inclusion and accessibility, ensuring everyone can enjoy a seamless online experience.",
  "property_seo_title_sitemap": "Sitemap | Cottages at Tallgrass Point",
  "property_seo_description_sitemap": "Uncover serene living at Cottages at Tallgrass Point in Owasso, OK. Check out our sitemap for an easy guide to your next home sweet home!",
  "property_seo_title_thankyou": "Thank You | Cottages at Tallgrass Point",
  "property_seo_description_thankyou": "Thank you for reaching out to Cottages at Tallgrass Point! Our team will connect with you soon to help you find your perfect home in Owasso, OK.",
  "property_seo_title_pets": "Pet Policy | Apartments in Owasso, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865099227",
  "amenities": [
    {
      "id": "ec_aee29ebbd18d4d42973d3a47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396451",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cccf14387da5d2f0af04b2d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396452",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0def6cef73ab53d5f9579af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396453",
      "title": "Courtyards with Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69e631b22d38c32299fd0541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396454",
      "title": "Limited Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57c969b5957f043ce94632c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396455",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0b327d11310b8e91c759267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396456",
      "title": "Onsite 24-Hour Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50d219d9af2390041d666ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396457",
      "title": "Onsite Management with Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10954a4e9ff9ff1b5dd6f5ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396458",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e43008c1f8dfae581a281400",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396459",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2fef4d3b06d353b3f6f97f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396460",
      "title": "Zero-Entry Resort-Style Pool with Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_954940653a69aa011dd7cf60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396461",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0757d176859bbbeb57921dee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396462",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab3aae66dfebbf0e3df18eb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396463",
      "title": "Internet Cafe with Gourmet Coffee",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80459687502f8a5aa5333faf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127396464",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_908c98062434fbc765ef9b1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397945",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_182a9157c12e217e745e8236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397946",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e8b5770ca753af08e86c0b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397947",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f9634cd4ca3d7abf4c17d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397948",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c1107d4364bac7b93b33263",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397949",
      "title": "Cozy Wood-Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fb3c06ca077a655690bd756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397950",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8171b9e448c360c5f99ddc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397951",
      "title": "Generous Closet Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2eb21d42fcb1b4d44476c89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397952",
      "title": "Handicapped Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b70b127b065ac217df7b8ad4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397953",
      "title": "Individual Climate Control with AC",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_794f94b0ffd56a8309ac5e11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397954",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95a2a955e096f3a6e43082b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397955",
      "title": "Side-by-Side Refrigerator with Filtered Water & Ice",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_792c9e9f71cea97662577901",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397956",
      "title": "Washer & Dryer Connection",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a168836048951f97f5cab9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397957",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87a2d9f2f277618c85655c2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397958",
      "title": "Unique Floor Plan with Extra Dining Area or Office Nook*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de541d8e5be0554249094921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397959",
      "title": "Designer Paint with Accent Wall",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de42083081da5a77b825d309",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397960",
      "title": "2-Inch Wood-Style Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72abdcf5adf7530dfd4fef11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "yardi",
      "external_id": "127397961",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d2133a12-bfaf-43ed-8c70-79e08b962fab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-4280-72ba-bbbc-1f101c14fbb6.webp",
      "image_media": {
        "alt_text": "Community dog park with agility equipment, benches, and waste station.",
        "public_id": "019fa493-4280-72ba-bbbc-1f101c14fbb6",
        "storage_key": "property/6767906449167039/019fa493-4280-72ba-bbbc-1f101c14fbb6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring agility equipment for your furry friends to play on, ample seating, and convenient waste stations.",
      "link": "",
      "alt_text": "Community dog park with agility equipment, benches, and waste station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ebfbdad4-2550-4186-8fca-67b8c2f776c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-427f-72ba-98aa-0025bbbd4bb0.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, sidewalks, and green lawns.",
        "public_id": "019fa493-427f-72ba-98aa-0025bbbd4bb0",
        "storage_key": "property/6767906449167039/019fa493-427f-72ba-98aa-0025bbbd4bb0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds and exteriors of the apartment buildings, featuring balconies and well-maintained sidewalks.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies, sidewalks, and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_644191a7-b2d1-496a-9cdd-a97b823b8c96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-3f7e-7393-b9df-0376f6dec546.webp",
      "image_media": {
        "alt_text": "Townhouse style apartment building with attached garages and a fire hydrant.",
        "public_id": "019fa493-3f7e-7393-b9df-0376f6dec546",
        "storage_key": "property/6767906449167039/019fa493-3f7e-7393-b9df-0376f6dec546.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of a townhouse-style apartment building featuring attached garages and a prominent fire hydrant in the foreground. Shows the architectural style and the property's layout.",
      "link": "",
      "alt_text": "Townhouse style apartment building with attached garages and a fire hydrant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b08048db-74e9-4325-ba7a-63168169357c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-47d1-718a-93e5-b8b0062de5f4.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and seating areas next to apartment buildings.",
        "public_id": "019fa493-47d1-718a-93e5-b8b0062de5f4",
        "storage_key": "property/6767906449167039/019fa493-47d1-718a-93e5-b8b0062de5f4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment and comfortable seating for pet owners. A great place for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment and seating areas next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c33789fc-ff30-4574-b8b1-e8818ca3a395",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-3212-70ae-9dbe-5bab01b5ce7c.webp",
      "image_media": {
        "alt_text": "Outdoor gathering area with picnic tables, grills, and a stone fireplace.",
        "public_id": "019fa493-3212-70ae-9dbe-5bab01b5ce7c",
        "storage_key": "property/6767906449167039/019fa493-3212-70ae-9dbe-5bab01b5ce7c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and socializing in our community's gathering area, complete with picnic tables, grills, and a cozy stone fireplace.",
      "link": "",
      "alt_text": "Outdoor gathering area with picnic tables, grills, and a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35fb291d-c29d-42db-bdf7-4a4bc4af20e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-31ca-749d-923e-e47afeb0bd9c.webp",
      "image_media": {
        "alt_text": "Swimming pool and outdoor seating area with grills at apartment complex.",
        "public_id": "019fa493-31ca-749d-923e-e47afeb0bd9c",
        "storage_key": "property/6767906449167039/019fa493-31ca-749d-923e-e47afeb0bd9c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the pool or relax in the outdoor lounge area, complete with grills for cookouts.",
      "link": "",
      "alt_text": "Swimming pool and outdoor seating area with grills at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c32e532-10dd-4ee7-8ed0-73b5f6610c59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-3745-7784-a87b-7eaed300c97f.webp",
      "image_media": {
        "alt_text": "View of the pool area and apartment buildings from a balcony.",
        "public_id": "019fa493-3745-7784-a87b-7eaed300c97f",
        "storage_key": "property/6767906449167039/019fa493-3745-7784-a87b-7eaed300c97f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and scenic apartment buildings.",
      "link": "",
      "alt_text": "View of the pool area and apartment buildings from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59118584-4edf-4700-812f-2ceb6c89d595",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-388d-705a-b0c8-2cb3bb25f818.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, walkways, and green lawn.",
        "public_id": "019fa493-388d-705a-b0c8-2cb3bb25f818",
        "storage_key": "property/6767906449167039/019fa493-388d-705a-b0c8-2cb3bb25f818.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex exterior, showcasing modern architecture and lush landscaping, inviting you to discover your new home.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies, walkways, and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f6fc492-5bad-463a-a803-78647e20f539",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-27b8-7768-8caa-8fcaf1b2552a.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and umbrellas in front of apartment buildings.",
        "public_id": "019fa493-27b8-7768-8caa-8fcaf1b2552a",
        "storage_key": "property/6767906449167039/019fa493-27b8-7768-8caa-8fcaf1b2552a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's BBQ grills and picnic areas, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and umbrellas in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e67baa69-c315-420e-b54e-b50867cf3bdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-213e-7474-9c0d-071bdd8a37ca.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs at apartment complex.",
        "public_id": "019fa493-213e-7474-9c0d-071bdd8a37ca",
        "storage_key": "property/6767906449167039/019fa493-213e-7474-9c0d-071bdd8a37ca.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool or relax on a lounge chair under the blue umbrellas.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_525f1865-d87b-4389-93c3-f71208570e10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-2471-736e-a7ea-4af2d92dcb8a.webp",
      "image_media": {
        "alt_text": "Covered patio with comfortable seating and pool views.",
        "public_id": "019fa493-2471-736e-a7ea-4af2d92dcb8a",
        "storage_key": "property/6767906449167039/019fa493-2471-736e-a7ea-4af2d92dcb8a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind on the covered patio, complete with plush seating and a view of the sparkling swimming pool.",
      "link": "",
      "alt_text": "Covered patio with comfortable seating and pool views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed274470-be36-469a-b630-3120725c0443",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-12e8-74bf-9e84-ff575266d972.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and manicured landscaping.",
        "public_id": "019fa493-12e8-74bf-9e84-ff575266d972",
        "storage_key": "property/6767906449167039/019fa493-12e8-74bf-9e84-ff575266d972.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Charming apartment building with balconies overlooking beautifully landscaped grounds and vibrant flowerbeds.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bdba609e-f49a-449b-9e90-14024ab05b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-1997-766b-8ceb-288662b3b19d.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with comfortable seating and a television.",
        "public_id": "019fa493-1997-766b-8ceb-288662b3b19d",
        "storage_key": "property/6767906449167039/019fa493-1997-766b-8ceb-288662b3b19d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious outdoor lounge area, complete with comfortable seating and a large television for your entertainment.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with comfortable seating and a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42289a14-1944-4882-b198-774deaa1d253",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-141f-7037-a392-fae3ad368453.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of an apartment building.",
        "public_id": "019fa493-141f-7037-a392-fae3ad368453",
        "storage_key": "property/6767906449167039/019fa493-141f-7037-a392-fae3ad368453.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded by umbrellas. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_327e76ca-142f-4b11-a62d-6390efe823c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-12c7-761c-9033-f2e75d95c653.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and a covered cabana.",
        "public_id": "019fa493-12c7-761c-9033-f2e75d95c653",
        "storage_key": "property/6767906449167039/019fa493-12c7-761c-9033-f2e75d95c653.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and a covered cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29fae3b6-2bc4-43f4-8fce-705e41adf052",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-1381-762f-9f88-5332ac6b6231.webp",
      "image_media": {
        "alt_text": "Large sparkling swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019fa493-1381-762f-9f88-5332ac6b6231",
        "storage_key": "property/6767906449167039/019fa493-1381-762f-9f88-5332ac6b6231.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by comfortable lounge chairs and shaded areas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Large sparkling swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28d565f9-0ffb-4f49-9986-4ddd18abfbd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-0f68-73c7-978e-c88e05656f9c.webp",
      "image_media": {
        "alt_text": "Entrance to apartment building with landscaping and a blue sculpture.",
        "public_id": "019fa493-0f68-73c7-978e-c88e05656f9c",
        "storage_key": "property/6767906449167039/019fa493-0f68-73c7-978e-c88e05656f9c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to the entrance of our apartment community, featuring beautiful landscaping, modern architecture, and an inviting atmosphere.",
      "link": "",
      "alt_text": "Entrance to apartment building with landscaping and a blue sculpture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_98c1a35f-d891-4923-9d06-17f78795bd83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa493-00f5-723e-b560-ac39c9b23a0c.webp",
      "image_media": {
        "alt_text": "Building entrance with manicured landscaping and blooming flowers.",
        "public_id": "019fa493-00f5-723e-b560-ac39c9b23a0c",
        "storage_key": "property/6767906449167039/019fa493-00f5-723e-b560-ac39c9b23a0c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome home to our beautiful community entrance, featuring lush greenery and vibrant flowers. Experience the charm and comfort of your new apartment home.",
      "link": "",
      "alt_text": "Building entrance with manicured landscaping and blooming flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4057571b-0727-4bb2-8126-7919ca74947f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f82a-7669-bcc5-f1b6adb268ef.webp",
      "image_media": {
        "alt_text": "The Cottages at Tallgrass Point monument sign with stone accents.",
        "public_id": "019fa492-f82a-7669-bcc5-f1b6adb268ef",
        "storage_key": "property/6767906449167039/019fa492-f82a-7669-bcc5-f1b6adb268ef.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to The Cottages at Tallgrass Point. This monument sign features the property name with stone and wood accents, surrounded by landscaping and a green lawn.",
      "link": "",
      "alt_text": "The Cottages at Tallgrass Point monument sign with stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ae0b425-bcaf-481a-9aad-46b8ff470f99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, nightstands, dresser, and mirror.",
        "public_id": "019fa492-f832-708a-90ce-ad72aff11a2e",
        "storage_key": "property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a king-size bed, elegant nightstands, and a dresser with a large mirror. The room is well-lit with a ceiling fan and large windows.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed, nightstands, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c82816e7-9531-4afb-a11c-a0e51add9281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
      "image_media": {
        "alt_text": "Modern home office with a white desk, chair, and large windows.",
        "public_id": "019fa492-f831-7081-879e-62d751ef822f",
        "storage_key": "property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Create your perfect workspace in this stylish home office, featuring a sleek white desk and comfortable seating, bathed in natural light from large windows.",
      "link": "",
      "alt_text": "Modern home office with a white desk, chair, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_816d1640-e5dd-4fc0-985d-0e7720d3f905",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f0ea-7474-9bef-65c0009146d1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fa492-f0ea-7474-9bef-65c0009146d1",
        "storage_key": "property/6767906449167039/019fa492-f0ea-7474-9bef-65c0009146d1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, stainless steel appliances including a dishwasher, microwave, and oven, with elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1cce8e20-3f37-402c-8cd3-3723f30220bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f0dc-707d-b451-93c87d643e79.webp",
      "image_media": {
        "alt_text": "A dining table with two bar stools next to a desk with a chair and a globe.",
        "public_id": "019fa492-f0dc-707d-b451-93c87d643e79",
        "storage_key": "property/6767906449167039/019fa492-f0dc-707d-b451-93c87d643e79.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals or work from home in this versatile dining and workspace area, featuring a modern table and a convenient desk setup.",
      "link": "",
      "alt_text": "A dining table with two bar stools next to a desk with a chair and a globe.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b47c9678-847d-4291-afd1-664dca9ae575",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-ebb9-70bb-8c1a-9ca2a35f9050.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, mirror, toilet, and shower/tub combo.",
        "public_id": "019fa492-ebb9-70bb-8c1a-9ca2a35f9050",
        "storage_key": "property/6767906449167039/019fa492-ebb9-70bb-8c1a-9ca2a35f9050.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into a clean and contemporary bathroom featuring a spacious vanity, modern fixtures, and a relaxing shower/tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, sink, mirror, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6dfc1e00-b5c5-43e0-a192-ebdd8bcf2793",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances including a dishwasher, stove, and microwave.",
        "public_id": "019fa492-eae7-7648-aec9-d18ca616f14a",
        "storage_key": "property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, granite countertops, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances including a dishwasher, stove, and microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_524b4598-e859-404a-b4cb-ba01774a8b21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-d2c1-7178-b915-e9e66a99c9d5.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and dining area.",
        "public_id": "019fa492-d2c1-7178-b915-e9e66a99c9d5",
        "storage_key": "property/6767906449167039/019fa492-d2c1-7178-b915-e9e66a99c9d5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable seating, and a modern dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb7a420c-d909-4ede-8a67-82267159fc27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-b0f7-735b-846a-ad774624f786.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, TV, and coffee table.",
        "public_id": "019fa491-b0f7-735b-846a-ad774624f786",
        "storage_key": "property/6767906449167039/019fa491-b0f7-735b-846a-ad774624f786.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, accent chair, and entertainment center with a flat-screen TV, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, TV, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93f7d77e-2a6c-4b0a-8f46-f41a2ec11942",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-bab6-7289-84df-0295e809c43d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a granite countertop.",
        "public_id": "019fa491-bab6-7289-84df-0295e809c43d",
        "storage_key": "property/6767906449167039/019fa491-bab6-7289-84df-0295e809c43d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring white cabinetry, a stainless steel oven and microwave, and a sleek granite countertop. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f7399ef-dcd4-4929-9365-66a1d6575c77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-9e6e-72be-a91b-51ee3a38f7c7.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, plush pillows, and a large headboard.",
        "public_id": "019fa491-9e6e-72be-a91b-51ee3a38f7c7",
        "storage_key": "property/6767906449167039/019fa491-9e6e-72be-a91b-51ee3a38f7c7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable and stylish bedroom, featuring a queen-size bed and ample space.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, plush pillows, and a large headboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcc4f8b0-a2a7-4ada-b7d9-d3ad23a2b182",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-ab8c-70fc-9253-14b321865cef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island with seating.",
        "public_id": "019fa491-ab8c-70fc-9253-14b321865cef",
        "storage_key": "property/6767906449167039/019fa491-ab8c-70fc-9253-14b321865cef.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in this beautifully appointed kitchen, featuring sleek countertops, ample cabinet space, and modern appliances perfect for any culinary endeavor.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_afbe7e4b-650f-478d-a14c-bc11a745d65b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-a933-71ad-8c52-dedec996a1e9.webp",
      "image_media": {
        "alt_text": "Living room and kitchen in an apartment with light gray walls, white cabinets, and a large sofa.",
        "public_id": "019fa491-a933-71ad-8c52-dedec996a1e9",
        "storage_key": "property/6767906449167039/019fa491-a933-71ad-8c52-dedec996a1e9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly transitions into a modern kitchen, featuring white cabinetry, a breakfast bar, and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room and kitchen in an apartment with light gray walls, white cabinets, and a large sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_692f6cb7-7444-47e1-aca1-8f3e9e00e7fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-975b-711f-af08-680eb838c80c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, toilet, and bathtub with a checkered shower curtain.",
        "public_id": "019fa491-975b-711f-af08-680eb838c80c",
        "storage_key": "property/6767906449167039/019fa491-975b-711f-af08-680eb838c80c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this beautifully appointed bathroom, featuring a spacious vanity, a clean white toilet, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, toilet, and bathtub with a checkered shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_112e154b-f81d-45a0-9474-f93e042e13a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-9850-72ec-8161-91abcb4f0551.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, marble countertop, and wood-look tile flooring.",
        "public_id": "019fa491-9850-72ec-8161-91abcb4f0551",
        "storage_key": "property/6767906449167039/019fa491-9850-72ec-8161-91abcb4f0551.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of this modern bathroom, featuring a spacious vanity with ample storage, a sleek marble countertop, and elegant wood-look tile flooring.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, marble countertop, and wood-look tile flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15af997c-d73b-4397-ae41-ef623c0fccbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-9494-7668-81b5-897132096824.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and window.",
        "public_id": "019fa491-9494-7668-81b5-897132096824",
        "storage_key": "property/6767906449167039/019fa491-9494-7668-81b5-897132096824.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstand with a lamp, and a wooden dresser. Large window with blinds provides natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c86120f-fdd2-4554-a705-5c0be42167ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-91e9-7571-b0a1-b310da2f5db2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fa491-91e9-7571-b0a1-b310da2f5db2",
        "storage_key": "property/6767906449167039/019fa491-91e9-7571-b0a1-b310da2f5db2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen, featuring white cabinetry, sleek granite countertops, and modern stainless steel appliances, including a dishwasher and microwave.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94f1ab6d-cb33-4639-a418-1cbc31b6ace9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-7793-75a9-abae-fab28c94e624.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with a sofa, armchair, TV, and bar stools.",
        "public_id": "019fa491-7793-75a9-abae-fab28c94e624",
        "storage_key": "property/6767906449167039/019fa491-7793-75a9-abae-fab28c94e624.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern living room and open-concept kitchen, perfect for entertaining guests or relaxing after a long day.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with a sofa, armchair, TV, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c56ba76-ee93-487f-b2af-a04749754931",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-6c3c-740d-a987-b484f7a0ef51.webp",
      "image_media": {
        "alt_text": "Open concept living, dining, and kitchen area with breakfast bar.",
        "public_id": "019fa491-6c3c-740d-a987-b484f7a0ef51",
        "storage_key": "property/6767906449167039/019fa491-6c3c-740d-a987-b484f7a0ef51.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with a breakfast bar, a dining area, and a comfortable living room space. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Open concept living, dining, and kitchen area with breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1381f220-cb58-43ad-b943-586cf794e5b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-6039-760c-87f2-1bb37a59e325.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-sized bed, wood dresser, and a ceiling fan.",
        "public_id": "019fa491-6039-760c-87f2-1bb37a59e325",
        "storage_key": "property/6767906449167039/019fa491-6039-760c-87f2-1bb37a59e325.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom featuring a plush queen-sized bed, ample storage with a wood dresser, and a ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "A cozy bedroom with a queen-sized bed, wood dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4d3f59f5-ce20-4e0f-8bd3-b74ee71384f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-7a0c-7349-a9ea-ce1d8e5f732b.webp",
      "image_media": {
        "alt_text": "Dining area with a dark wood table and six chairs, featuring abstract wall art.",
        "public_id": "019fa491-7a0c-7349-a9ea-ce1d8e5f732b",
        "storage_key": "property/6767906449167039/019fa491-7a0c-7349-a9ea-ce1d8e5f732b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining experience in this apartment, complete with a modern dining set and elegant wall decor.",
      "link": "",
      "alt_text": "Dining area with a dark wood table and six chairs, featuring abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_917b6a80-2596-4e71-9e2f-b202ff414598",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-74ee-72ce-8b7d-67a21321ace3.webp",
      "image_media": {
        "alt_text": "Living room with a plush sofa, ottoman, and TV.",
        "public_id": "019fa491-74ee-72ce-8b7d-67a21321ace3",
        "storage_key": "property/6767906449167039/019fa491-74ee-72ce-8b7d-67a21321ace3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, decorative ottoman, and a mounted television, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a plush sofa, ottoman, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1e6c7a0-d2a7-43a2-86b1-cddd7ae3c8fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-61c2-7191-a501-5b319669fb44.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, near a glass door leading to a balcony.",
        "public_id": "019fa491-61c2-7191-a501-5b319669fb44",
        "storage_key": "property/6767906449167039/019fa491-61c2-7191-a501-5b319669fb44.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this cozy dining area, complete with a round table and comfortable seating. The space offers easy access to outdoor living.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, near a glass door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f93ebf6e-cd51-490d-b9b4-5cd4f6abd99b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-b74f-7554-b53c-949766fbad40.webp",
      "image_media": {
        "alt_text": "A vanity with mirrors and a dining area with a table and chairs.",
        "public_id": "019fa490-b74f-7554-b53c-949766fbad40",
        "storage_key": "property/6767906449167039/019fa490-b74f-7554-b53c-949766fbad40.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover a stylish vanity area and a spacious dining room, perfect for entertaining or enjoying a quiet meal.",
      "link": "",
      "alt_text": "A vanity with mirrors and a dining area with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3b77d0d-36f0-4508-81cd-de6f3eb62de2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-af21-709d-b2c1-dd5c8e52f6e8.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, sofa, coffee table, and dining area.",
        "public_id": "019fa490-af21-709d-b2c1-dd5c8e52f6e8",
        "storage_key": "property/6767906449167039/019fa490-af21-709d-b2c1-dd5c8e52f6e8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in the cozy living room featuring a beautiful fireplace, comfortable seating, and a dedicated dining space. Perfect for entertaining or quiet evenings at home.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace, sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47215345-c978-453b-b908-78a511339068",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-b32b-722d-a5e4-e64be9a7ac8d.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a queen-size bed with wood furniture and a ceiling fan.",
        "public_id": "019fa490-b32b-722d-a5e4-e64be9a7ac8d",
        "storage_key": "property/6767906449167039/019fa490-b32b-722d-a5e4-e64be9a7ac8d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, complete with a plush queen bed, elegant wood furnishings, and a cooling ceiling fan for ultimate relaxation.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a queen-size bed with wood furniture and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_739a6b0b-34d5-457c-81c7-14bee1d5df0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-844a-7214-98bb-9d68258e2a01.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, treadmills, ellipticals, dumbbells, and exercise balls.",
        "public_id": "019fa490-844a-7214-98bb-9d68258e2a01",
        "storage_key": "property/6767906449167039/019fa490-844a-7214-98bb-9d68258e2a01.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with a variety of cardio and strength training machines to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with weight machines, treadmills, ellipticals, dumbbells, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae8cf86c-edd1-4e8f-ad8b-739eb004da11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-837c-761b-9683-738e5e0e36e0.webp",
      "image_media": {
        "alt_text": "Community lounge area with a stone fireplace, kitchen island with bar stools, and a TV showing a soccer game.",
        "public_id": "019fa490-837c-761b-9683-738e5e0e36e0",
        "storage_key": "property/6767906449167039/019fa490-837c-761b-9683-738e5e0e36e0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax in our stylish community lounge, featuring a cozy stone fireplace, a modern kitchen island perfect for gathering, and entertainment options.",
      "link": "",
      "alt_text": "Community lounge area with a stone fireplace, kitchen island with bar stools, and a TV showing a soccer game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7916c4e-4d9e-451e-b483-8ba517f6dbe6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-77e4-75e9-aebb-0c3a5376450e.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with seating areas, a kitchenette, and a large clock on the wall.",
        "public_id": "019fa490-77e4-75e9-aebb-0c3a5376450e",
        "storage_key": "property/6767906449167039/019fa490-77e4-75e9-aebb-0c3a5376450e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating, a convenient kitchenette, and elegant decor.",
      "link": "",
      "alt_text": "Spacious community lounge with seating areas, a kitchenette, and a large clock on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58ba1d90-905c-4c73-b570-96cff5a01d90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-784b-7600-bece-593929aa0497.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and a bench.",
        "public_id": "019fa490-784b-7600-bece-593929aa0497",
        "storage_key": "property/6767906449167039/019fa490-784b-7600-bece-593929aa0497.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, recumbent bikes, and a full range of free weights and benches.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0dca4648-4827-465b-8143-f76fe6e8b1ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "9311 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls. They also highlight the good value, lively atmosphere, and friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-3f33-7789-91a5-8d4ee6638790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3f33-7789-91a5-8d4ee6638790",
        "storage_key": "property/6767906449167039/019d270e-3f33-7789-91a5-8d4ee6638790.webp",
        "width": 560,
        "height": 315
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/owasso?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7489778363057715607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.2890186",
      "poi_longitude": "-95.8379704",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-516-1075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7423-736f-b085-fcb2307a978d",
        "storage_key": "property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cw0P4XxtocRlzl2GL0J8Wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4e01da7b-ccac-4fb6-8c25-e070e6303b3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "MAD Eats",
      "poi_type": "Restaurants",
      "poi_address": "201 S Main St STE #130, Owasso, OK 74055, USA",
      "poi_short_description": "Casual eatery serving burgers, tacos, mac and cheese, sandwiches, breakfast items, meatloaf and shakes.",
      "poi_long_description": "People say this diner serves delicious burgers, shakes, and pies, and offers unique options like Chicken Fried Meatloaf and Taco Mac & Cheese. They also highlight the generous portions, fun atmosphere, and friendly service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-3f76-734f-bf89-37604088fb98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3f76-734f-bf89-37604088fb98",
        "storage_key": "property/6767906449167039/019d270e-3f76-734f-bf89-37604088fb98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.madeatsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1802710814106412544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mad-eats",
      "poi_latitude": "36.2635117",
      "poi_longitude": "-95.8542858",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-401-4353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7423-736f-b085-fcb2307a978d",
        "storage_key": "property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZLFS_bwtocRAGaRK--DBBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_6d63f2bb-05d1-46bc-872b-9b0709f6c64b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "13301 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves hot, crispy, and flavorful chicken fingers, along with Texas toast and crinkle-cut fries. They highlight the fast and friendly service, and the clean and well-organized restaurant. They also like the kind and engaging staff and management.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-3f69-746b-aa75-72665fce0f91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3f69-746b-aa75-72665fce0f91",
        "storage_key": "property/6767906449167039/019d270e-3f69-746b-aa75-72665fce0f91.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/owasso/13301-e.-96th-st.-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=11347752542593289881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.2934128",
      "poi_longitude": "-95.826651",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-376-9426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7423-736f-b085-fcb2307a978d",
        "storage_key": "property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwe5cajwtocRmQ5PhNBQe50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ca85fddb-979d-4ffe-aba9-756b8b599cf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Restaurants",
      "poi_address": "11590 N 140th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-3fb7-70d9-9884-6d0166658498.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3fb7-70d9-9884-6d0166658498",
        "storage_key": "property/6767906449167039/019d270e-3fb7-70d9-9884-6d0166658498.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ok/owasso/11590-n-140th-e-ave?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM4MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075741749885667753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "36.32114",
      "poi_longitude": "-95.8192628",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-371-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7423-736f-b085-fcb2307a978d",
        "storage_key": "property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZXXJSH6tocRqQn-B2zN7Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_606f225b-2590-407e-b242-9ff414b6b1e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12015 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches and meals. They also highlight the fast and friendly service, and the clean restaurant.\n\nSome reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4439-729b-b539-ad8a6b719cd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4439-729b-b539-ad8a6b719cd9",
        "storage_key": "property/6767906449167039/019d270e-4439-729b-b539-ad8a6b719cd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/owasso-market?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068432268636994183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.29352799999999",
      "poi_longitude": "-95.8402253",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-272-7201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7423-736f-b085-fcb2307a978d",
        "storage_key": "property/6767906449167039/019d270e-7423-736f-b085-fcb2307a978d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTTsZDJ7wtocRhzp0HeRClSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_35d092f8-7f7f-4527-94ef-c90b3a0a2ec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9450 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the helpful and friendly staff, and the clean and tidy store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-43bd-778f-b5ab-a4a94f705013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-43bd-778f-b5ab-a4a94f705013",
        "storage_key": "property/6767906449167039/019d270e-43bd-778f-b5ab-a4a94f705013.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Owasso/OK/Owasso/74055/8922?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1344320956374293089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.2902973",
      "poi_longitude": "-95.8317215",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-376-9975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7396-733e-8f5c-6caaf5b2054a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7396-733e-8f5c-6caaf5b2054a",
        "storage_key": "property/6767906449167039/019d270e-7396-733e-8f5c-6caaf5b2054a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP-C7bKHwtocRYZrNjMn8pxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_6e31adfc-726a-4bea-a00c-9be1201b9e2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "12001 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and services, including appliances, lumber, and assistance with home projects. They also highlight the friendly and helpful staff, as well as the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4434-728c-a0c6-ae4cb5cff011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4434-728c-a0c6-ae4cb5cff011",
        "storage_key": "property/6767906449167039/019d270e-4434-728c-a0c6-ae4cb5cff011.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Owasso/1500?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1500-_-na-_-0-_-0&y_source=1_MTE4NDM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10101766130383154022&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.29417",
      "poi_longitude": "-95.83639",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-0881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7396-733e-8f5c-6caaf5b2054a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7396-733e-8f5c-6caaf5b2054a",
        "storage_key": "property/6767906449167039/019d270e-7396-733e-8f5c-6caaf5b2054a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJWmL4Z_wtocRZmuPLcauMIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_69832b8c-72ca-4156-a4c4-0c2765cf6ea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9601 N 133rd E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic products, and sprouts. They highlight the good sales on health and vitamin products, and the convenient size of the store. They also like the friendly, knowledgeable, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4470-706b-bf52-d78c42fabc00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4470-706b-bf52-d78c42fabc00",
        "storage_key": "property/6767906449167039/019d270e-4470-706b-bf52-d78c42fabc00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/owasso/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=6349055451709502037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.294403",
      "poi_longitude": "-95.8260493",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-516-6656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-738d-730b-88f1-275c2df6f79a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-738d-730b-88f1-275c2df6f79a",
        "storage_key": "property/6767906449167039/019d270e-738d-730b-88f1-275c2df6f79a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbryiqfwtocRVfJmaktgHFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9e094247-e84f-46a2-8d40-1053dd265d24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "9046 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-48a8-7643-aece-7074e7a00e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-48a8-7643-aece-7074e7a00e84",
        "storage_key": "property/6767906449167039/019d270e-48a8-7643-aece-7074e7a00e84.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7226706442748966127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "36.291631",
      "poi_longitude": "-95.8415924",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-3699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7396-733e-8f5c-6caaf5b2054a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7396-733e-8f5c-6caaf5b2054a",
        "storage_key": "property/6767906449167039/019d270e-7396-733e-8f5c-6caaf5b2054a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOkQZzwtocR7zQUkDhrSmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_70691c45-2289-459d-9181-33023f3962d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Reasor's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11815 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Supermarket, bakery, and pharmacy chain offering a variety of goods including meat and produce.",
      "poi_long_description": "People say this grocery store offers amazing produce, a great bakery, and a wide variety of groceries and essentials. They also highlight the friendly and helpful staff, and the clean and well-laid-out store.\n\nSome reviews mention items can be out of stock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-491e-71ee-b9d7-4af0df5e9f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-491e-71ee-b9d7-4af0df5e9f2f",
        "storage_key": "property/6767906449167039/019d270e-491e-71ee-b9d7-4af0df5e9f2f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.reasors.com/stores/owasso-south-86th",
      "poi_directions_map_url": "https://maps.google.com/?cid=9836905338792957670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reasors",
      "poi_latitude": "36.2798262",
      "poi_longitude": "-95.8425677",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-6211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-738d-730b-88f1-275c2df6f79a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-738d-730b-88f1-275c2df6f79a",
        "storage_key": "property/6767906449167039/019d270e-738d-730b-88f1-275c2df6f79a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3xRcJHwtocR5tbll0m1g4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3a13155c-653a-4f48-88a6-5176013e9e45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Owasso Library",
      "poi_type": "Education",
      "poi_address": "314 E 5th Ave Suite 202, Owasso, OK 74055, USA",
      "poi_short_description": "Community resource offering books and movies, plus educational programs and events.",
      "poi_long_description": "People say this public library has a wide selection of books, including vegetarian cookbooks, and offers a food drive that benefits the community. They also highlight the helpful and friendly staff who greet visitors and offer assistance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4a8e-73fe-85bc-003a7dd0e8a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4a8e-73fe-85bc-003a7dd0e8a1",
        "storage_key": "property/6767906449167039/019d270e-4a8e-73fe-85bc-003a7dd0e8a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/owasso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8627652818677722310&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-library",
      "poi_latitude": "36.2581947",
      "poi_longitude": "-95.8497147",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-73db-74be-ad49-2740d511bb1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-73db-74be-ad49-2740d511bb1b",
        "storage_key": "property/6767906449167039/019d270e-73db-74be-ad49-2740d511bb1b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnaj5dPbwtocRxuyu_oaUu3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_547b7bfa-b8dd-4008-99f6-7a4c12113c76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including sea lions, elephants, and tigers, as well as a dinosaur exhibit and a playground. They highlight the fun, family-friendly atmosphere and the ongoing improvements to the exhibits. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4a41-7128-95cf-fed047376851.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4a41-7128-95cf-fed047376851",
        "storage_key": "property/6767906449167039/019d270e-4a41-7128-95cf-fed047376851.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_68cac6aa-5d01-4af2-9cb1-b10f86bae520",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Tulsa Air and Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "3624 N 74th E Ave, Tulsa, OK 74115, USA",
      "poi_short_description": "Detailed history from 1897 to the space age plus interactive exhibits, vintage aircraft & a theater.",
      "poi_long_description": "People say this museum offers a fun and educational experience with interactive exhibits, a planetarium, and a variety of aircraft to see up close. They also highlight the friendly and informative staff, and the great value for the price.\n\nOther reviews mention some exhibits can be under repair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4d2d-7080-a69f-812caa8cfa3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4d2d-7080-a69f-812caa8cfa3d",
        "storage_key": "property/6767906449167039/019d270e-4d2d-7080-a69f-812caa8cfa3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tulsamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16931592180727714246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-air-and-space-museum",
      "poi_latitude": "36.2067509",
      "poi_longitude": "-95.8957281",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-834-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7854-7748-9e7d-14b77c872a42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7854-7748-9e7d-14b77c872a42",
        "storage_key": "property/6767906449167039/019d270e-7854-7748-9e7d-14b77c872a42.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9UUGf_xtocRxpEOhmEZ-eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e7d5eadc-e13c-41e7-a888-5780588e4e73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Airtopia Adventure Park - Owasso",
      "poi_type": "Entertainment",
      "poi_address": "12932 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Multi-dimensional indoor amusement center offers trampolines, a warrior course, and more.",
      "poi_long_description": "People say this theme park offers a variety of fun activities, including trampolines, obstacle courses, and a virtual reality experience. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention some attractions can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4d85-73b9-ac3a-90f76901e389.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4d85-73b9-ac3a-90f76901e389",
        "storage_key": "property/6767906449167039/019d270e-4d85-73b9-ac3a-90f76901e389.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.airtopiapark.com/owasso?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729509317578422024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airtopia-adventure-park---owasso",
      "poi_latitude": "36.2766921",
      "poi_longitude": "-95.8278842",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-401-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-TfgZDxtocRCHfF7PbgwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_74afd980-50e6-42da-835c-a27ebbb50d3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Owasso Stadium",
      "poi_type": "Entertainment",
      "poi_address": "12901 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-4fd3-75cc-adcf-2dfcd430af9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4fd3-75cc-adcf-2dfcd430af9d",
        "storage_key": "property/6767906449167039/019d270e-4fd3-75cc-adcf-2dfcd430af9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2455",
      "poi_directions_map_url": "https://maps.google.com/?cid=14776732685769457826&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-stadium",
      "poi_latitude": "36.2814643",
      "poi_longitude": "-95.8285307",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-77f2-717b-80fe-12c70ac76b2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-77f2-717b-80fe-12c70ac76b2d",
        "storage_key": "property/6767906449167039/019d270e-77f2-717b-80fe-12c70ac76b2d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5n_8kDxtocRokAxVBaAEc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7e764fd2-7b12-4186-895a-c26dffcf8aae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Mohawk Park Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "4301 Creek Dr, Tulsa, OK 74115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5019-753d-b025-3770a7137e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5019-753d-b025-3770a7137e23",
        "storage_key": "property/6767906449167039/019d270e-5019-753d-b025-3770a7137e23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/government/departments/park-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1440625490899638440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mohawk-park-splash-pad",
      "poi_latitude": "36.2168713",
      "poi_longitude": "-95.9039008",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbIdbbzvtocRqBhyT0Ah_hM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_8eaa5a8a-3065-4f05-ac96-cc466852367d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "507 E 2nd Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Gym with the latest cardio and strength-training equipment, as well as classes and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and amenities, including a sauna, tanning beds, and hydro massage chairs. They highlight the affordable prices, 24/7 access, and friendly, helpful staff. They also like the clean facilities and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-51b5-71d0-b941-b938f5c83dda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-51b5-71d0-b941-b938f5c83dda",
        "storage_key": "property/6767906449167039/019d270e-51b5-71d0-b941-b938f5c83dda.webp",
        "width": 825,
        "height": 462
      },
      "poi_business_url": "https://10gym.com/owasso-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8859217771743011312&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.2653089",
      "poi_longitude": "-95.8504279",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-609-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG85Rt3n3tocR8OGREKBD8no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_939bb7be-3ea6-45ca-b32f-c65d95713e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "SAHO Owasso Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12555 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5205-7259-941d-536491bb9404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5205-7259-941d-536491bb9404",
        "storage_key": "property/6767906449167039/019d270e-5205-7259-941d-536491bb9404.webp",
        "width": 1128,
        "height": 636
      },
      "poi_business_url": "https://sahovets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7283601458760437127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saho-owasso-animal-hospital",
      "poi_latitude": "36.2797463",
      "poi_longitude": "-95.8339312",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZu1473wtocRh83uwu-MFGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_2ffe6c1e-af1a-4c1f-95e1-589a96c52aac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Barber Sports Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "11622 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Popular barbershop specializing in straight-razor shaves and detailed haircuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5498-744c-b398-3975656006af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5498-744c-b398-3975656006af",
        "storage_key": "property/6767906449167039/019d270e-5498-744c-b398-3975656006af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://placegem.top/barber-sports-lounge-cnilcpw",
      "poi_directions_map_url": "https://maps.google.com/?cid=11273226578980552883&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barber-sports-lounge",
      "poi_latitude": "36.277631",
      "poi_longitude": "-95.8451781",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-609-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQYHk5HwtocRs8CgcNiLcpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_2cc1f43a-cc70-493a-8fa6-8e62f45daa72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "9045 N 121st E Ave Suite 1200, Owasso, OK 74055, USA",
      "poi_short_description": "Casual shop for men's and boys' haircuts as well as beard trimming and shaping. Also offers MVP treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5534-76d9-a4c8-ede242b27834.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5534-76d9-a4c8-ede242b27834",
        "storage_key": "property/6767906449167039/019d270e-5534-76d9-a4c8-ede242b27834.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ok-owasso-ok103?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=13715315186473060055&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-owasso",
      "poi_latitude": "36.2901849",
      "poi_longitude": "-95.8404563",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4_3H5zwtocR10Y_yH6WVr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7208ba0f-7dab-4163-8fc2-4dcd92389a4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 N 129th E Ave Ste 124, Owasso, OK 74055, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-55b6-7189-9c2f-8198ba053143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-55b6-7189-9c2f-8198ba053143",
        "storage_key": "property/6767906449167039/019d270e-55b6-7189-9c2f-8198ba053143.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ok/owasso/9500-n-129th-e-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1714296183721100132&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "36.2912538",
      "poi_longitude": "-95.8310068",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-4561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ4Yy6DwtocRZAOB3ktnyhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0d559323-8290-40f8-98d5-6b1cab7c35a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Floyd's 99 Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "11340 E 96th St N Ste 400, Owasso, OK 74055, USA",
      "poi_short_description": "Chain barber shop offering haircuts, shaves, and shoulder massages, plus grooming products.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5718-706a-ad95-342dd175e8c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5718-706a-ad95-342dd175e8c0",
        "storage_key": "property/6767906449167039/019d270e-5718-706a-ad95-342dd175e8c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.floydsbarbershop.com/locations/oklahoma/tulsa/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890106331849848605&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "floyds-99-barbershop",
      "poi_latitude": "36.292582",
      "poi_longitude": "-95.8459996",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-973-4610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8ASMSbxtocRHXdQqh2Sw8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_c4bf0f59-8e01-461f-abee-812af5c5b8ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Airbenders",
      "poi_type": "Health and Wellness",
      "poi_address": "9395 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Well-maintained facility offering classes, birthday parties and special events such as Parents Night Out.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5987-74d8-9c5c-274a45088fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5987-74d8-9c5c-274a45088fda",
        "storage_key": "property/6767906449167039/019d270e-5987-74d8-9c5c-274a45088fda.webp",
        "width": 960,
        "height": 588
      },
      "poi_business_url": "http://airbendersgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11097384753689398637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbenders",
      "poi_latitude": "36.2877573",
      "poi_longitude": "-95.8384187",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-928-4288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeSEalLxtocRbQ1-E6PUAZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d4a571f2-6c6d-4320-a575-10006d1fafb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "M Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "9540 N Garnett Rd Suite #114, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-59dc-73fd-a248-fcb9bcc599ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-59dc-73fd-a248-fcb9bcc599ef",
        "storage_key": "property/6767906449167039/019d270e-59dc-73fd-a248-fcb9bcc599ef.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12922025453757066769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "m-nails",
      "poi_latitude": "36.2924919",
      "poi_longitude": "-95.8497314",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-274-7384",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwa-6fnvxtocREe6-ta9BVLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_3dffb849-2db2-4131-8aac-5a1942fef40a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Vintage Barbershop Co.",
      "poi_type": "Health and Wellness",
      "poi_address": "421 E 2nd Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Relaxed salon offering an array of services including haircuts, hot towel shaves and beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5aae-716b-a159-b91d307703ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5aae-716b-a159-b91d307703ba",
        "storage_key": "property/6767906449167039/019d270e-5aae-716b-a159-b91d307703ba.webp",
        "width": 1206,
        "height": 1191
      },
      "poi_business_url": "http://www.vintagebarbershopcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8470976327735755158&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vintage-barbershop-co",
      "poi_latitude": "36.2648651",
      "poi_longitude": "-95.8520044",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-998-6919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcc8BAvxtocRlsFuwxb0jnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_9478ac24-a9cf-42f7-9156-a52441dbd836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "LUSH Nails & Spa OWASSO",
      "poi_type": "Health and Wellness",
      "poi_address": "11560 N 135th E Ave Unit 105, Owasso, OK 74055, USA",
      "poi_short_description": "Clean salon for manicures and pedicures, plus acrylic options and waxing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5b4c-77cf-8bcd-155d6a3c2d45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5b4c-77cf-8bcd-155d6a3c2d45",
        "storage_key": "property/6767906449167039/019d270e-5b4c-77cf-8bcd-155d6a3c2d45.webp",
        "width": 608,
        "height": 341
      },
      "poi_business_url": "https://lushnailsandspaowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3743164198816847017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lush-nails--spa-owasso",
      "poi_latitude": "36.3204521",
      "poi_longitude": "-95.825409",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-371-3952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_-V94X7tocRqRRwtgFk8jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_680d9897-fb58-46e7-a126-572f93645bc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Ascension St. John Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "12451 E 100th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5e8f-70c4-9676-a7799913da95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5e8f-70c4-9676-a7799913da95",
        "storage_key": "property/6767906449167039/019d270e-5e8f-70c4-9676-a7799913da95.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/oklahoma/oktul/owasso-ascension-st-john-owasso?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4519634255069400250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-st-john-owasso",
      "poi_latitude": "36.2992565",
      "poi_longitude": "-95.8353676",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-781a-716b-b3f6-fe760e7f4252.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-781a-716b-b3f6-fe760e7f4252",
        "storage_key": "property/6767906449167039/019d270e-781a-716b-b3f6-fe760e7f4252.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtX2-TAv6tocRukwZsGj3uD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a6fb91c6-980f-4446-be03-7c3e153b65e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Warren Clinic Urgent Care - Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "11610 N 137th E Ave, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5dfe-765c-bbf5-7ff5ab2a0c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5dfe-765c-bbf5-7ff5ab2a0c4e",
        "storage_key": "property/6767906449167039/019d270e-5dfe-765c-bbf5-7ff5ab2a0c4e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/warren-clinic-urgent-care-owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=2973186174730484356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "warren-clinic-urgent-care---owasso",
      "poi_latitude": "36.3231905",
      "poi_longitude": "-95.8194792",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-928-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-781a-716b-b3f6-fe760e7f4252.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-781a-716b-b3f6-fe760e7f4252",
        "storage_key": "property/6767906449167039/019d270e-781a-716b-b3f6-fe760e7f4252.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5pJ53v7tocRhLrpwxLhQik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_84446bb2-e4e6-4f30-87bd-8f9b588cadcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Mohawk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6700 Mohawk Blvd, Tulsa, OK 74115, USA",
      "poi_short_description": "Sprawling park with hiking & walking trails, plus a zoo, The Oxley Nature Center & a golf course.",
      "poi_long_description": "People say this park offers lovely trails, a disc golf course, and a zoo. They highlight the expansive green spaces, lakes, and picnic areas, and the tranquil and natural setting. They also like the well-maintained facilities and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5f47-747e-b486-3200beda713d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5f47-747e-b486-3200beda713d",
        "storage_key": "property/6767906449167039/019d270e-5f47-747e-b486-3200beda713d.webp",
        "width": 677,
        "height": 453
      },
      "poi_business_url": "https://www.cityoftulsa.org/government/departments/park-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5925424848019900704&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mohawk-park",
      "poi_latitude": "36.223452",
      "poi_longitude": "-95.9030179",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-596-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7b7d-76bc-b8ef-deb68fd228f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7b7d-76bc-b8ef-deb68fd228f1",
        "storage_key": "property/6767906449167039/019d270e-7b7d-76bc-b8ef-deb68fd228f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0ZOwQXutocRIMl_SYFWO1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f216bb8d-4765-447f-ab79-53f954ea7cd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "O'Brien Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6149 N Lewis Ave, Tulsa, OK 74130, USA",
      "poi_short_description": "Relaxed recreation area with ball fields, a playground and a community garden.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-5f9e-7374-a81c-cbf5c9ad6054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-5f9e-7374-a81c-cbf5c9ad6054",
        "storage_key": "property/6767906449167039/019d270e-5f9e-7374-a81c-cbf5c9ad6054.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/o-brien-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18006865631678456310&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "obrien-park",
      "poi_latitude": "36.2453281",
      "poi_longitude": "-95.9544754",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-591-6008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7b7d-76bc-b8ef-deb68fd228f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7b7d-76bc-b8ef-deb68fd228f1",
        "storage_key": "property/6767906449167039/019d270e-7b7d-76bc-b8ef-deb68fd228f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Zh1pB7vtocR9mFiNuM85fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d99cd0cb-a8e1-4336-ac79-f71eb8b2a386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "The Patriot Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5790 N Patriot Dr, Owasso, OK 74055, USA",
      "poi_short_description": "Relaxed, welcoming golf club boasting scenic views and featuring an eatery.",
      "poi_long_description": "People say this golf course offers a challenging and beautiful course with amazing views and elevation changes. They highlight the friendly and welcoming atmosphere, and the spacious and well-maintained facilities, including a nice clubhouse and bar area. They also like the friendly staff and members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-626d-779a-934e-2e604546e014.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-626d-779a-934e-2e604546e014",
        "storage_key": "property/6767906449167039/019d270e-626d-779a-934e-2e604546e014.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.patriotgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13926276483344965530&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-patriot-golf-club",
      "poi_latitude": "36.2386179",
      "poi_longitude": "-95.7725533",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-272-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7c55-7058-b07c-3332f70f98cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7c55-7058-b07c-3332f70f98cf",
        "storage_key": "property/6767906449167039/019d270e-7c55-7058-b07c-3332f70f98cf.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2fvcfH2tocRmh-nUa0SRME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_df07290b-f870-4ddd-bf33-d6f45b69a0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Oxley Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6700 Mohawk Blvd, Tulsa, OK 74115, USA",
      "poi_short_description": "800-acre park with trails & an interpretive center with hands-on exhibits & a wildlife viewing area.",
      "poi_long_description": "People say this nature preserve offers a variety of trails, a pond, and opportunities to see different plants and animals. They highlight the peaceful and beautiful atmosphere, and the informative exhibits and interpretive signs. They also like the knowledgeable and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-64f3-76cd-b7d6-bef330aeef00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-64f3-76cd-b7d6-bef330aeef00",
        "storage_key": "property/6767906449167039/019d270e-64f3-76cd-b7d6-bef330aeef00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.oxleynaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11481077389293266307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oxley-nature-center",
      "poi_latitude": "36.2234573",
      "poi_longitude": "-95.9030304",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-596-9054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7b7d-76bc-b8ef-deb68fd228f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7b7d-76bc-b8ef-deb68fd228f1",
        "storage_key": "property/6767906449167039/019d270e-7b7d-76bc-b8ef-deb68fd228f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Y_SacPxtocRgyWYYw77VJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c9760da-38c9-498f-ac42-0d094f591a08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Mohawk Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5223 E 41st St N, Tulsa, OK 74115, USA",
      "poi_short_description": "Sprawling property providing 2 golf courses, a driving range, cafeteria-style eatery & retail shop.",
      "poi_long_description": "People say this golf course has cool hole designs.\n\nOther reviews mention the course conditions can be poor and the greens can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-6403-7668-9995-9c949b8e2d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-6403-7668-9995-9c949b8e2d2d",
        "storage_key": "property/6767906449167039/019d270e-6403-7668-9995-9c949b8e2d2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tulsagolf.org/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6409748559381811545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mohawk-park-golf-course",
      "poi_latitude": "36.214925",
      "poi_longitude": "-95.917307",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-425-6871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7c55-7058-b07c-3332f70f98cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7c55-7058-b07c-3332f70f98cf",
        "storage_key": "property/6767906449167039/019d270e-7c55-7058-b07c-3332f70f98cf.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJaenOgBLutocRWVGGvVoA9Fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_e3ddd10e-0461-4b3f-bf85-cfad804a7c96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Tulsa International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7777 Airport Dr, Tulsa, OK 74115, USA",
      "poi_short_description": "Airport offering domestic flights plus eateries, a military lounge & 2 hotels on its grounds.",
      "poi_long_description": "People say this airport is easy to navigate and has short security lines. They also highlight the friendly staff and clean facilities.\n\nOther reviews mention the baggage claim can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-64b0-7658-a147-e476b967c166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-64b0-7658-a147-e476b967c166",
        "storage_key": "property/6767906449167039/019d270e-64b0-7658-a147-e476b967c166.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flytulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11620207539197010978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-international-airport",
      "poi_latitude": "36.2011836",
      "poi_longitude": "-95.8849646",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-838-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7c57-747f-92ab-6ff43c7f6be4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7c57-747f-92ab-6ff43c7f6be4",
        "storage_key": "property/6767906449167039/019d270e-7c57-747f-92ab-6ff43c7f6be4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbar6xzytocRImQnvjBFQ6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ceae7728-29e0-4fef-8c5b-55f5002a1f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Gundys",
      "poi_type": "Transportation & Transit",
      "poi_address": "7806 N 172nd E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-66e3-708e-8cb7-16aaece273a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-66e3-708e-8cb7-16aaece273a0",
        "storage_key": "property/6767906449167039/019d270e-66e3-708e-8cb7-16aaece273a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gundysairport.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4107118366967304947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gundys",
      "poi_latitude": "36.2670849",
      "poi_longitude": "-95.7841404",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-272-1523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7c57-747f-92ab-6ff43c7f6be4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7c57-747f-92ab-6ff43c7f6be4",
        "storage_key": "property/6767906449167039/019d270e-7c57-747f-92ab-6ff43c7f6be4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRmOtxH3tocR85KR8WRq_zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f84cfa68-8d16-483f-9b8a-69f76e94db22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Airman Acres Airport-OK93",
      "poi_type": "Transportation & Transit",
      "poi_address": "E 126th St N, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-68d0-774f-be55-6f5d8560fb19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-68d0-774f-be55-6f5d8560fb19",
        "storage_key": "property/6767906449167039/019d270e-68d0-774f-be55-6f5d8560fb19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14842558028454321639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airman-acres-airport-ok93",
      "poi_latitude": "36.3351884",
      "poi_longitude": "-95.8927046",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-371-2014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7c57-747f-92ab-6ff43c7f6be4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7c57-747f-92ab-6ff43c7f6be4",
        "storage_key": "property/6767906449167039/019d270e-7c57-747f-92ab-6ff43c7f6be4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyvsHZ35tocR510kPONb-80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a8bcdeba-d9ff-4686-a4ea-fa85e5119193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Verizon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6929 N Lakewood Ave, Tulsa, OK 74117, USA",
      "poi_short_description": "Telecommunications company offering cell phones, wireless plans, accessories & more.",
      "poi_long_description": "Telecommunications company offering cell phones, wireless plans, accessories & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-69b9-700f-acb3-f0377f6dab6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-69b9-700f-acb3-f0377f6dab6f",
        "storage_key": "property/6767906449167039/019d270e-69b9-700f-acb3-f0377f6dab6f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.verizonwireless.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8994536342959291733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "verizon",
      "poi_latitude": "36.2548751",
      "poi_longitude": "-95.904602",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-590-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF26cn9HvtocRVf1tGSYD03w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b758c329-94a1-44f5-8ecc-6a8d969d32c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "City of Owasso",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-694c-702f-ba2a-4a972a602f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-694c-702f-ba2a-4a972a602f2d",
        "storage_key": "property/6767906449167039/019d270e-694c-702f-ba2a-4a972a602f2d.webp",
        "width": 601,
        "height": 290
      },
      "poi_business_url": "https://www.cityofowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16667434515310460285&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-owasso",
      "poi_latitude": "36.2637562",
      "poi_longitude": "-95.8555663",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-7cd1-7101-a485-247e0839e499.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-7cd1-7101-a485-247e0839e499",
        "storage_key": "property/6767906449167039/019d270e-7cd1-7101-a485-247e0839e499.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydO3w_XwtocRfT0qQmKfTuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a4c73274-d0ce-4253-b737-3e6370f894cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "American Airlines Hangar 1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Tulsa, OK 74116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12623668118602683959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-airlines-hangar-1",
      "poi_latitude": "36.2079968",
      "poi_longitude": "-95.8765942",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Sn_VaDxtocRN5a8U0VHMK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7375cafe-34b4-4f5f-b636-c81629777f8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Omni Air Transport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3217 N Sheridan Rd Hanger #38, Tulsa, OK 74115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-6b8c-7255-a8b9-015d20950424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-6b8c-7255-a8b9-015d20950424",
        "storage_key": "property/6767906449167039/019d270e-6b8c-7255-a8b9-015d20950424.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.flyomni.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=595356618034182559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "omni-air-transport",
      "poi_latitude": "36.2014696",
      "poi_longitude": "-95.9037751",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-836-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Ynk8NV4bIcRn_malLAhQwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e493c46d-1a48-4ed9-9b8f-4a4f5349d944",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Legacy Living",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12150 E 96th St N Suite 200, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-6ef6-723f-8ec1-d4ec8fd37b88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-6ef6-723f-8ec1-d4ec8fd37b88",
        "storage_key": "property/6767906449167039/019d270e-6ef6-723f-8ec1-d4ec8fd37b88.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.legacysl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17704443287973334600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-living",
      "poi_latitude": "36.2914006",
      "poi_longitude": "-95.8382875",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-376-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-778a-75de-90aa-4a8ef712675c",
        "storage_key": "property/6767906449167039/019d270e-778a-75de-90aa-4a8ef712675c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQR0-J7wtocRSA6zRV7RsvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0839da21-22cb-42bf-bf56-e7b6227eca75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Owasso High School - West Campus",
      "poi_type": "Education",
      "poi_address": "8800 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6932044658716961630&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-high-school-west-campus",
      "poi_latitude": "36.2813748",
      "poi_longitude": "-95.8314087",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6312-7152-b78b-cd0da3fb66c1",
        "storage_key": "property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJswik87zwtocRXuv3ueORM2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ef85ea15-ab5c-45db-a9ea-4db54f7d54fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "The University of Tulsa, North Campus",
      "poi_type": "Education",
      "poi_address": "2450 E Marshall St, Tulsa, OK 74110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5685378246054826000&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa-north-campus",
      "poi_latitude": "36.1711869",
      "poi_longitude": "-95.9551735",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6312-7152-b78b-cd0da3fb66c1",
        "storage_key": "property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj6IE8kTstocRENDUcWSF5k4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_464afbc8-6fce-4453-9d94-9c1b05da41b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Ator Elementary",
      "poi_type": "Education",
      "poi_address": "1500 N Ash St, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ator.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14743269976607447178&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ator-elementary",
      "poi_latitude": "36.2814099",
      "poi_longitude": "-95.8543435",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-272-2204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6312-7152-b78b-cd0da3fb66c1",
        "storage_key": "property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD4ML7YjwtocRilheN-6dmsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_00001a77-380b-40bb-bd2c-930949bee758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Rejoice Christian School",
      "poi_type": "Education",
      "poi_address": "13407 E 106th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-2448-73b9-bbfe-2f04de434680.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2448-73b9-bbfe-2f04de434680",
        "storage_key": "property/6767906449167039/019d7917-2448-73b9-bbfe-2f04de434680.webp",
        "width": 1280,
        "height": 460
      },
      "poi_business_url": "http://www.rejoiceschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12487743676581848759&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rejoice-christian-school",
      "poi_latitude": "36.3107571",
      "poi_longitude": "-95.825138",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-516-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6312-7152-b78b-cd0da3fb66c1",
        "storage_key": "property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN-OPPBH6tocRt6bKALZgTa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8d0dd06a-e412-4793-87c4-38803d519596",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Owasso Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "9341 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://owassoprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17717246513680442630&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-preparatory-academy",
      "poi_latitude": "36.2910614",
      "poi_longitude": "-95.829034",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-378-0344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6312-7152-b78b-cd0da3fb66c1",
        "storage_key": "property/6767906449167039/019cfb51-6312-7152-b78b-cd0da3fb66c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvXr7DqP7tocRBmXzjdVN4PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_098cd666-c692-4b9c-928c-90d7688f0a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Restaurants",
      "poi_address": "11909 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Local brewpub chain serving burgers, pizza, American comfort food & beer in a brick-walled space.",
      "poi_long_description": "People say this American restaurant serves delicious dishes like the soy-glazed salmon, chopped and chipped nachos, and shrimp mango tacos. They highlight the good food, great beer choices, and fun atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-2454-737c-a046-8eb5b20d2391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2454-737c-a046-8eb5b20d2391",
        "storage_key": "property/6767906449167039/019d7917-2454-737c-a046-8eb5b20d2391.webp",
        "width": 823,
        "height": 1280
      },
      "poi_business_url": "https://bricktownbrewery.com/location/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=9149037493883191025&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "36.2934651",
      "poi_longitude": "-95.8410255",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-321-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dZu-53wtocR8T6jgyDp934",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8ded4bc9-bff1-480b-9a2d-a16bc27980f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "9263 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Some diners say this chicken wings restaurant offers delicious wings with a variety of sauces, especially the spicy buffalo sauce, and a great chicken sandwich.\n\nOther reviews mention the service can be slow and the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-2461-713a-8ccd-6b9fdc93463d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2461-713a-8ccd-6b9fdc93463d",
        "storage_key": "property/6767906449167039/019d7917-2461-713a-8ccd-6b9fdc93463d.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/ok/owasso/9263-north-owasso-expressway/sports-bar-1356?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMjExNy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10631001762345126062&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "36.2883267",
      "poi_longitude": "-95.8389341",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-376-4911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Rk_NJnwtocRrggiA8fniJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_3a3e192d-c7ad-4f94-b699-ebd915d00fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "9035 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop serves good coffee and protein lattes. They also highlight the friendly and efficient service, and the clean restrooms.\n\nOther reviews mention the drinks can be made incorrectly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-25f9-7603-9113-98bf0b2e6b1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-25f9-7603-9113-98bf0b2e6b1c",
        "storage_key": "property/6767906449167039/019d7917-25f9-7603-9113-98bf0b2e6b1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/10257/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4300999228917353778&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "36.2889508",
      "poi_longitude": "-95.8417368",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-376-2504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6320-7268-9a55-d98c9fa39bb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6320-7268-9a55-d98c9fa39bb4",
        "storage_key": "property/6767906449167039/019cfb51-6320-7268-9a55-d98c9fa39bb4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJuxHgHZTwtocRMg3Z0gI4sDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_2fb2d32e-785a-43ca-bb73-de286c78fd31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "12903 E 96th St N A, Owasso, OK 74055, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves tasty pizza with a variety of toppings, as well as fried mushrooms, wings, and salads. They highlight the half-price drinks during happy hour and the quick service. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-2f84-72c4-a04b-4607fed12dc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2f84-72c4-a04b-4607fed12dc1",
        "storage_key": "property/6767906449167039/019d7917-2f84-72c4-a04b-4607fed12dc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8117728085082139184&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "36.2934902",
      "poi_longitude": "-95.8287993",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-928-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8N2R6fwtocRMGqIDq_2p3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_c90e2050-8bb6-466f-9f75-27969213574b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Amelia's Wood Fired Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "122 N Boston Ave, Tulsa, OK 74103, USA",
      "poi_short_description": "Popular, upmarket choice featuring wood-fired American plates in an airy setting with arty accents.",
      "poi_long_description": "People say this American restaurant serves delicious entrees, appetizers, and desserts, and offers a well-balanced cocktail menu. They highlight the attentive and knowledgeable service, and the warm and inviting atmosphere. They also like the extensive wine list and the option to sit at the chef's counter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-2ce1-7238-99f0-4dbe4c0920bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2ce1-7238-99f0-4dbe4c0920bf",
        "storage_key": "property/6767906449167039/019d7917-2ce1-7238-99f0-4dbe4c0920bf.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "http://amelias.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3169802210572686709&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amelia-s-wood-fired-cuisine",
      "poi_latitude": "36.1583455",
      "poi_longitude": "-95.9925996",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 19 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-728-2435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z-4wYLrtocRddVu8VBm_Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fceae37a-c5cd-4339-9a65-94cfa336af35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9072 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves delicious breadsticks, salad, and Alfredo sauce, and they praise the unlimited soup, salad, and breadsticks. They also highlight the friendly and attentive service, and the peaceful atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-3250-766c-a19a-fba782f3b8e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3250-766c-a19a-fba782f3b8e6",
        "storage_key": "property/6767906449167039/019d7917-3250-766c-a19a-fba782f3b8e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/owasso/owasso/1778?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:owasso-ok-1778_pl:locurl_rd:1625",
      "poi_directions_map_url": "https://maps.google.com/?cid=10788694414358487658&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.292518",
      "poi_longitude": "-95.839812",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-1436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExXEOpzwtocRaiIUrmgkuZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b203bc08-5f93-45da-84ac-be6c372cc1d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Baja Jack's Burrito Shack",
      "poi_type": "Restaurants",
      "poi_address": "9045 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Casual, kid-friendly Mexican restaurant serving up tacos, burritos & beer in a festive setting.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, burritos, and quesadillas, and offers a fresh salsa bar with a variety of options. They highlight the generous portions, affordable prices, and the build-your-own burrito option. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-312a-76fe-bc67-4ff1cd508d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-312a-76fe-bc67-4ff1cd508d6b",
        "storage_key": "property/6767906449167039/019d7917-312a-76fe-bc67-4ff1cd508d6b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://bajajacksonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17114742089379239786&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "baja-jack-s-burrito-shack",
      "poi_latitude": "36.289514",
      "poi_longitude": "-95.840748",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBalsEJzwtocRalfgo0DHg-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_305644bc-bae7-4ee3-a3b7-fce5d26872f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "9017 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Diners say this restaurant serves delicious burgers, especially the tavern set, jalapeño heat wave burger, and blue cheese crumble burger, with bottomless steak fries. They also highlight the friendly and attentive service, and the tasty campfire sauce.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-34f8-7707-a2df-2c9052977f2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-34f8-7707-a2df-2c9052977f2c",
        "storage_key": "property/6767906449167039/019d7917-34f8-7707-a2df-2c9052977f2c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/ok/owasso/owasso-444",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263201928979773951&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "36.2867073",
      "poi_longitude": "-95.844652",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-376-9094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpc8-R5vwtocR_3kdCeJbELg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_de53e8d5-a6cc-4c4c-b9a0-84feaae17a23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Trails End Barbecue & Grill",
      "poi_type": "Restaurants",
      "poi_address": "8888 N Garnett Rd, Owasso, OK 74055, USA",
      "poi_short_description": "Wood-smoked pork, chicken & more served in a down-to-earth setting with a rustic, country vibe.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and turkey, and offers complimentary cobbler. They highlight the generous portions, reasonable prices, and casual atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-42ad-7629-8ba3-427feaddaaf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-42ad-7629-8ba3-427feaddaaf0",
        "storage_key": "property/6767906449167039/019d7917-42ad-7629-8ba3-427feaddaaf0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.trailsendbbq.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4438774694451998559&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trails-end-barbecue-grill",
      "poi_latitude": "36.281271",
      "poi_longitude": "-95.8489",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-272-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-630e-766a-b81a-f35d4a8c4a8d",
        "storage_key": "property/6767906449167039/019cfb51-630e-766a-b81a-f35d4a8c4a8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYmBC4_wtocRX-_NJBGymT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_e93446fe-541b-407b-b094-22b3a89cf146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "JCPenney",
      "poi_type": "Shopping & Retail",
      "poi_address": "9056 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_long_description": "People say this department store offers a wide range of items. They also highlight the staff can be polite, friendly, and willing to assist.\n\nOther reviews mention the checkout can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-3da4-734a-9c36-e3c9961e4865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3da4-734a-9c36-e3c9961e4865",
        "storage_key": "property/6767906449167039/019d7917-3da4-734a-9c36-e3c9961e4865.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcpenney.com/locations/ok/owasso/clothing-stores-owasso-ok-2522.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17776153884315619919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jcpenney",
      "poi_latitude": "36.2921963",
      "poi_longitude": "-95.8420199",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-401-2460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631a-766f-ad73-a0e225bfb91b",
        "storage_key": "property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbafcw53wtocRTxJQk8aVsfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7e3ecfb9-d153-4a31-93ef-2ae157df7f69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "11650 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-45fb-76b8-aec0-0fb9ff8c3bc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-45fb-76b8-aec0-0fb9ff8c3bc3",
        "storage_key": "property/6767906449167039/019d7917-45fb-76b8-aec0-0fb9ff8c3bc3.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11650+e+86th+st+n-owasso-ok-74055/id=15762",
      "poi_directions_map_url": "https://maps.google.com/?cid=13683546810451569391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.2777266",
      "poi_longitude": "-95.8442867",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-272-9595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631e-768c-939a-f226390f30f4",
        "storage_key": "property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4MDiZHwtocR7yplWFO55b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_31bf14b5-8446-4d2d-940f-2b1c472694d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "9010 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the helpful and friendly staff.\n\nSome reviews mention the store can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-4387-778f-b4f1-0a06c7a5e85e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb51-4387-778f-b4f1-0a06c7a5e85e",
        "storage_key": "property/6767906449167039/019cfb51-4387-778f-b4f1-0a06c7a5e85e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/owasso/2095",
      "poi_directions_map_url": "https://maps.google.com/?cid=15682582055552125240&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.2895032",
      "poi_longitude": "-95.8446908",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-401-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631a-766f-ad73-a0e225bfb91b",
        "storage_key": "property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhdk_kJzwtocROIkZJkq5o9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_31a60a47-5807-4964-940c-3fd4cfb91c6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9259 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide variety of products, including fresh produce, meat, and sundry items. They highlight the reasonable prices and good value. They also like the fun and unique products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-4a2f-72bb-9d4c-e9a9ccff15c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4a2f-72bb-9d4c-e9a9ccff15c8",
        "storage_key": "property/6767906449167039/019d7917-4a2f-72bb-9d4c-e9a9ccff15c8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/owasso/9259-n-owasso-expy/f277",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750233354463553084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.287999",
      "poi_longitude": "-95.839577",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6321-734f-9f57-cae7d11e749d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6321-734f-9f57-cae7d11e749d",
        "storage_key": "property/6767906449167039/019cfb51-6321-734f-9f57-cae7d11e749d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ33WgTJnwtocRPCbr9hVbs8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_6b96072d-ed9a-417e-b37a-3c316fd39066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12912 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-4af8-73d7-8aa2-57d583953687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4af8-73d7-8aa2-57d583953687",
        "storage_key": "property/6767906449167039/019d7917-4af8-73d7-8aa2-57d583953687.webp",
        "width": 1280,
        "height": 582
      },
      "poi_business_url": "https://www.walmart.com/store/5840-owasso-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=582772205887777448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.2765555",
      "poi_longitude": "-95.8289555",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-0030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-6321-734f-9f57-cae7d11e749d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-6321-734f-9f57-cae7d11e749d",
        "storage_key": "property/6767906449167039/019cfb51-6321-734f-9f57-cae7d11e749d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ86Ke_7vwtocRqGrpzDtsFgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ed7ec8bb-36d1-4463-9a9a-cbefb502522f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "The Scarlett Rose Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "8528 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.facebook.com/thescarlettrose918/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8910779915793786797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-scarlett-rose-boutique",
      "poi_latitude": "36.2776698",
      "poi_longitude": "-95.8307871",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-516-2354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631a-766f-ad73-a0e225bfb91b",
        "storage_key": "property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKW2Ok4nxtocRreeSQB9zqXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "womens_clothing_store"
    },
    {
      "id": "custom_e3b63396-e550-487d-87ba-fb8e1eb1ee5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "The Shops on 86th Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "12711 E 86th Pl N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jandjreynolds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8141062832359108418&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-shops-on-86th-place",
      "poi_latitude": "36.2800905",
      "poi_longitude": "-95.8316265",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-296-9945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631a-766f-ad73-a0e225bfb91b",
        "storage_key": "property/6767906449167039/019cfb51-631a-766f-ad73-a0e225bfb91b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK_duQbzwtocRQm_mSIPd-nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b63bef3d-9fb1-4914-aaa7-2226b491c36c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-5223-776d-a571-e19cf53a3e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5223-776d-a571-e19cf53a3e93",
        "storage_key": "property/6767906449167039/019d7917-5223-776d-a571-e19cf53a3e93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "5 hours 58 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-627c-758f-b7ad-3f63d4847220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-627c-758f-b7ad-3f63d4847220",
        "storage_key": "property/6767906449167039/019cfb51-627c-758f-b7ad-3f63d4847220.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_67d74209-7ff9-4786-ab4a-c9c0cf9d27f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Cain's Ballroom",
      "poi_type": "Entertainment",
      "poi_address": "423 N Main St, Tulsa, OK 74103, USA",
      "poi_short_description": "Famed 1924 dance hall & concert venue with a full bar presenting country, rock & other live bands.",
      "poi_long_description": "People say this live music venue offers a wide variety of drinks and BBQ, and hosts a diverse range of artists and bands. They highlight the historic atmosphere, excellent acoustics, and convenient parking. They also like the friendly staff and efficient service at the bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-4d77-761d-94c2-07a5b636913f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb51-4d77-761d-94c2-07a5b636913f",
        "storage_key": "property/6767906449167039/019cfb51-4d77-761d-94c2-07a5b636913f.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "http://www.cainsballroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2392430961435331881&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cain-s-ballroom",
      "poi_latitude": "36.160996",
      "poi_longitude": "-95.994941",
      "poi_miles_from_property": "14.5 mi",
      "poi_walking_minutes": "5 hours 19 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-584-2306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631e-768c-939a-f226390f30f4",
        "storage_key": "property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJebBVvpzrtocRKc3_pUifMyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_c5e03480-9ec0-4e5a-a416-32da43323b4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-55cd-73cd-8cf4-bd50f53ae20e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-55cd-73cd-8cf4-bd50f53ae20e",
        "storage_key": "property/6767906449167039/019d7917-55cd-73cd-8cf4-bd50f53ae20e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "21.7 mi",
      "poi_walking_minutes": "7 hours 58 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631e-768c-939a-f226390f30f4",
        "storage_key": "property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_f4262162-3386-4f6e-9f49-f1dad3153a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Tulsa Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "110 E 2nd St S, Tulsa, OK 74103, USA",
      "poi_short_description": "6 venues presenting dance, theater, music & other programs by local & visiting artists.",
      "poi_long_description": "People say this performing arts theater offers a variety of shows, including Broadway productions, local theater, ballet, and concerts. They highlight the excellent acoustics, comfortable seating, and good sightlines from most seats. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-545f-773a-8789-db61ae09c5c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-545f-773a-8789-db61ae09c5c1",
        "storage_key": "property/6767906449167039/019d7917-545f-773a-8789-db61ae09c5c1.webp",
        "width": 821,
        "height": 313
      },
      "poi_business_url": "http://www.tulsapac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1663529134971770182&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-performing-arts-center",
      "poi_latitude": "36.154635",
      "poi_longitude": "-95.989282",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 23 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-596-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631e-768c-939a-f226390f30f4",
        "storage_key": "property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmblR2HjrtocRRlWBO-8KFhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_6dec2c51-ad7e-449f-aed1-fb089af69919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "The Cave House",
      "poi_type": "Entertainment",
      "poi_address": "1623 Charles Page Blvd, Tulsa, OK 74127, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this tourist attraction offers a unique and fascinating experience with its whimsical, cave-like exterior and quirky, eclectic interior. They also highlight the knowledgeable and passionate management who provides captivating tours, sharing stories about the house's history and rumored connections to prohibition-era tunnels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-5bfd-7707-a317-b56122aa54ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5bfd-7707-a317-b56122aa54ea",
        "storage_key": "property/6767906449167039/019d7917-5bfd-7707-a317-b56122aa54ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cavehousetulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2036454794667285882&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cave-house",
      "poi_latitude": "36.1517261",
      "poi_longitude": "-96.0112601",
      "poi_miles_from_property": "15.9 mi",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-378-1952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631e-768c-939a-f226390f30f4",
        "storage_key": "property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5fkfgzrtocRet1IndjwQhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_f361a3e7-6402-4b81-911e-fb2d64ebacd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Tulsa Botanic Garden",
      "poi_type": "Entertainment",
      "poi_address": "3900 Tulsa Botanic Dr, Tulsa, OK 74127, USA",
      "poi_short_description": "Botanic garden with floral terraces, a lakeside promenade, lotus pool & prairie trail, plus events.",
      "poi_long_description": "People say this botanical garden offers beautiful gardens, water features, sculptures, and a variety of flora, including flowers, trees, and shrubs. They highlight the peaceful and relaxing vibe, and the family-friendly and educational experience. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019d7917-5b53-7478-9155-008e4247a879.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5b53-7478-9155-008e4247a879",
        "storage_key": "property/6767906449167039/019d7917-5b53-7478-9155-008e4247a879.webp",
        "width": 1280,
        "height": 704
      },
      "poi_business_url": "https://www.tulsabotanic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15418899865116188645&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-botanic-garden",
      "poi_latitude": "36.2068636",
      "poi_longitude": "-96.0621357",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 43 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 918-289-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb51-631e-768c-939a-f226390f30f4",
        "storage_key": "property/6767906449167039/019cfb51-631e-768c-939a-f226390f30f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZRo6nvrtocR5Z-RB7zv-tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_007c8640-c305-44b5-b3e5-bf8ee4e77984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Bailey Education Group (Elementary Charter School)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bailey-education-group-elementary-charter-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e97af8c7-f6c4-425c-97d5-a1a8b515f34a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Tulsa Technology Center Owasso Campus",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tulsa-technology-center-owasso-campus",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6cc2dccf-ae62-4b81-8647-2faab5311c53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Owasso 6th/7th/8th Grade Centers",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "owasso-6th-7th-8th-grade-centers",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3ed28de-020a-4778-870f-fcad070a036f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "poi_name": "Lone Star Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "lone-star-steakhouse",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_79c0af3b8a570a65a1473e84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_42e64f3f951177fb26bf81c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_57673d6958866aac443d9092",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6199139773973a2eff8a21fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8b8b95e0b0c681bc9f77a348",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_bf4e2378bc4e3532093ccbef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c17d7cd7-ff0d-447e-a997-6fc650c064a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "rating": "5.0",
      "name": "Sherri Judkins",
      "text": "We appreciated their help and got all our issues resolved. We appreciated the Tallgrass management Communication and the maintenance folks following through quickly in getting our needs met!\nThank you so much!",
      "date": "2026-01-24",
      "title": ""
    },
    {
      "id": "custom_5bb99fa9-fc81-4e54-9d9f-eb43476f6a9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "rating": "5.0",
      "name": "Dana Callison",
      "text": "The issue is not finished being fixed but the issue has been addressed with a solution coming soon. Maintenance always does a good job.\nUPDATE: The job was completed when they said it would be. Whoot whoot! Great job Chris.",
      "date": "2025-12-31",
      "title": ""
    },
    {
      "id": "custom_8d14634c-b615-42dc-8012-74d89812d99f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "rating": "5.0",
      "name": "Dana Lynn",
      "text": "I absolutely love the ladies in the office.. They have been so helpful with everything & every question I have asked.. just started moving in so don't have much more to say..",
      "date": "2025-12-18",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_409c59aa-e091-48c5-8c28-f567f47fca0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Discover the Cottages at Tallgrass Point apartments with this immersive walkthrough virtual tour experience with LCP Media",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb52-286e-77d4-bba6-53f7f1df49ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of apartment complex pool area with lounge chairs and buildings in the background.",
        "public_id": "019cfb52-286e-77d4-bba6-53f7f1df49ec",
        "storage_key": "property/6767906449167039/019cfb52-286e-77d4-bba6-53f7f1df49ec.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cottages at Tallgrass Point Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=6304ba07d279307c9f877810"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-b16f-75ee-b7f3-56b6286d5785",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cottages-at-tallgrass-point",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039"
    },
    {
      "lead_collector_id": "019cf79d-b1e4-7059-858d-7cfd3c8bd6d5",
      "lead_source": "LANDING_PAGE",
      "name": "cottages-at-tallgrass-point",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-owasso-ok",
      "search_query": "pet friendly apartments in Owasso OK",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Owasso, OK",
      "h2_subtitle": "Discover pet friendly living at Cottages at Tallgrass Point. Your furry friends are welcome in our spacious Owasso, OK community.",
      "page_copy": "Looking for pet friendly apartments in Owasso, OK? At Cottages at Tallgrass Point, we warmly welcome you and your pets. Our community provides a comfortable and spacious living environment designed with both you and your furry friends in mind. \n\nLocated in the vibrant city of Owasso, our apartments offer a variety of top-notch amenities such as a side-by-side refrigerator with filtered water & ice, ensuring you have all the conveniences of modern living. Our pet-friendly policy makes it easy for you to enjoy freedom and comfort, whether you're taking a stroll or visiting our resident clubhouse. Discover the perfect blend of comfort and convenience, right here in Owasso, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Owasso, OK",
      "seo_description": "Find pet friendly apartments at Cottages at Tallgrass Point in Owasso, OK, with amenities for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-tulsa-county",
      "search_query": "luxury apartments with pool in Tulsa County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool - Tulsa County",
      "h2_subtitle": "Explore luxury living at Cottages at Tallgrass Point. Enjoy our exquisite apartments, complete with a pool, in Tulsa County.",
      "page_copy": "Experience luxury apartments with a pool in Tulsa County at Cottages at Tallgrass Point. Our community offers residents the perfect blend of elegance and relaxation. With our modern amenities, you can dive into luxury living and enjoy unparalleled comfort in a vibrant Owasso location.\n\nOur community features many high-end amenities like a side-by-side refrigerator with filtered water & ice and generous closet space. The pool area is a great spot to unwind and enjoy the Oklahoma sunshine, making it a standout feature of our property. Situated within Tulsa County, you'll find the Cottages at Tallgrass Point offers not just a home, but a lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool - Tulsa County",
      "seo_description": "Discover luxury apartments with a pool at Cottages at Tallgrass Point in Tulsa County, offering top-tier amenities and elegant living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-near-74055",
      "search_query": "apartments with in-unit laundry near 74055",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Near 74055",
      "h2_subtitle": "Find apartments with in-unit laundry near zip code 74055. Cottages at Tallgrass Point offers convenient living in Owasso, OK.",
      "page_copy": "If you're searching for apartments with in-unit laundry near the 74055 area, look no further than Cottages at Tallgrass Point. Located in Owasso, OK, our community provides a convenient and modern lifestyle close to all essentials. \n\nWith amenities such as side-by-side refrigerators with filtered water and ice, our apartments are designed to offer both comfort and convenience. The generous closet space and onsite management with package receiving add to the ease of living here. Enjoy accessible luxury with our in-unit laundry facilities, perfectly situated near everything you need.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Near 74055",
      "seo_description": "Discover convenient living at Cottages at Tallgrass Point with in-unit laundry, located near Owasso, OK 74055.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "owasso-apartments-with-dog-park",
      "search_query": "Owasso apartments with dog park",
      "category": "Amenity",
      "h1_title": "Owasso Apartments with Dog Park Access",
      "h2_subtitle": "Explore Owasso apartments featuring access to a dog park. Cottages at Tallgrass Point offers pet-friendly living for you and your furry friends.",
      "page_copy": "Searching for Owasso apartments with access to a dog park? Discover Cottages at Tallgrass Point, where we prioritize both your comfort and your pet's happiness. Our pet-friendly community in Owasso, OK is designed with features that cater to you and your four-legged companions.\n\nIn addition to dog park access, we offer a wide array of amenities like a side-by-side refrigerator with filtered water and generous closet space. The welcoming atmosphere at Cottages at Tallgrass Point ensures delight for both residents and their pets. Experience how our community combines modern living with pet-friendly features in a prime Owasso location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Owasso Apartments with Dog Park Access",
      "seo_description": "Find pet-friendly Owasso apartments with dog park access at Cottages at Tallgrass Point, offering a welcoming environment for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "owasso-apartments-air-conditioning",
      "search_query": "Owasso OK apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Owasso, OK Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool in Owasso, OK with our air-conditioned apartments. Cottages at Tallgrass Point offers comfortable living with modern amenities.",
      "page_copy": "If you're seeking Owasso, OK apartments with air conditioning, Cottages at Tallgrass Point is your ideal address. Our community ensures you stay comfortable year-round, thanks to well-equipped air-conditioned units designed with your lifestyle in mind.\n\nBeyond providing cool comfort, our apartments feature luxury amenities like a side-by-side refrigerator with filtered water and ice. Enjoy generous closet space and the convenience of onsite management with package receiving. At Cottages at Tallgrass Point, you’ll find modern living perfectly combined with the comforts of home in vibrant Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Owasso, OK Apartments with Air Conditioning",
      "seo_description": "Find comfortable living in air-conditioned apartments at Cottages at Tallgrass Point, Owasso, OK, offering modern amenities and convenience for residents.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-owasso-ok",
      "search_query": "one bedroom apartments Owasso OK",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Owasso, OK",
      "h2_subtitle": "Discover one bedroom apartments in Owasso, OK. Cottages at Tallgrass Point offers spacious and stylish living.",
      "page_copy": "Looking for one bedroom apartments in Owasso, OK? Welcome to Cottages at Tallgrass Point, where spacious and stylish one-bedroom units await you. Situated in the vibrant community of Owasso, our apartments offer a perfect balance of comfort and convenience.\n\nEach one-bedroom apartment comes with modern amenities such as side-by-side refrigerators with filtered water, ensuring a lifestyle of luxury and ease. Experience expansive closet space and the benefits of on-site management with package receiving. At Cottages at Tallgrass Point, our one-bedroom apartments cater to your needs, all in the sought-after location of Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Owasso, OK",
      "seo_description": "Explore stylish one-bedroom apartments in Owasso, OK at Cottages at Tallgrass Point, featuring modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-tulsa-county",
      "search_query": "two bedroom apartments near Tulsa County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Tulsa County",
      "h2_subtitle": "Find spacious two bedroom apartments near Tulsa County. Cottages at Tallgrass Point offers modern amenities in a great location.",
      "page_copy": "Searching for two bedroom apartments near Tulsa County? Discover comfort and convenience at Cottages at Tallgrass Point. Our two-bedroom units offer ample space and modern amenities, perfect for those seeking a blend of style and functionality in convenient proximity to Tulsa County.\n\nEnjoy a host of features including side-by-side refrigerators with filtered water, generous closet space, and a welcoming resident clubhouse. With additional perks like on-site management and package receiving services, living near Tulsa County at Cottages at Tallgrass Point means having everything you need right at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Tulsa County",
      "seo_description": "Explore two bedroom apartments near Tulsa County at Cottages at Tallgrass Point, offering modern features and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-st-john-owasso",
      "search_query": "apartments near Ascension St. John Owasso OK",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension St. John Owasso",
      "h2_subtitle": "Discover convenient living in apartments near Ascension St. John Owasso, OK. Cottages at Tallgrass Point offers proximity and comfort.",
      "page_copy": "Looking for apartments near Ascension St. John in Owasso, OK? Consider making Cottages at Tallgrass Point your new home. Ideally located, our community provides easy access to Ascension St. John, making your commute seamless and stress-free.\n\nOur apartments come with a range of desirable features, such as side-by-side refrigerators with filtered water and ice, generous closet space, and convenient on-site management. Enjoy the benefits of living in a community that prioritizes comfort and convenience, while being just moments away from Ascension St. John Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension St. John Owasso, OK",
      "seo_description": "Find convenience at Cottages at Tallgrass Point, with apartments near Ascension St. John Owasso, OK. Enjoy modern living close to key amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "cottages-tallgrass-point-warren-clinic-urgent-care",
      "search_query": "Cottages at Tallgrass Point by Warren Clinic Urgent Care Owasso",
      "category": "Hospital",
      "h1_title": "Cottages at Tallgrass Point Near Warren Clinic",
      "h2_subtitle": "Live at Cottages at Tallgrass Point, conveniently near Warren Clinic Urgent Care in Owasso. Discover comfort and easy access to healthcare.",
      "page_copy": "Cottages at Tallgrass Point offers ideal living just a short distance from Warren Clinic Urgent Care in Owasso. This prime location ensures you have quick access to essential healthcare services while enjoying a peaceful community atmosphere.\n\nAt Cottages at Tallgrass Point, you'll find modern amenities like a side-by-side refrigerator with filtered water, ample closet space, and a welcoming resident clubhouse. On-site management and package receiving services add to the convenience of living here. Experience a balanced lifestyle with excellent healthcare access and comfortable apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottages at Tallgrass Point by Warren Clinic Owasso",
      "seo_description": "Live comfortably at Cottages at Tallgrass Point near Warren Clinic Urgent Care in Owasso, with modern amenities and convenient healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "apartments-near-mohawk-park-tulsa",
      "search_query": "apartments near Mohawk Park Tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Mohawk Park, Tulsa",
      "h2_subtitle": "Explore apartments near Mohawk Park in Tulsa. Experience the perfect blend of nature and modern living at Cottages at Tallgrass Point.",
      "page_copy": "For those who enjoy the tranquility of nature, Cottages at Tallgrass Point offers an exceptional living experience with apartments conveniently near Mohawk Park in Tulsa. Our community provides a perfect balance of natural beauty and modern conveniences, just a short drive from the park's expansive green spaces.\n\nResidents at Cottages at Tallgrass Point can indulge in various amenities, such as side-by-side refrigerators with filtered water and spacious closets. Our community also features a welcoming resident clubhouse and on-site management, making it an ideal choice for those seeking comfort and a vibrant lifestyle close to Mohawk Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mohawk Park, Tulsa",
      "seo_description": "Find your home at Cottages at Tallgrass Point, near Mohawk Park in Tulsa, where nature meets modern living. Explore our comfortable apartments today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "owasso-apartments-near-obrien-park",
      "search_query": "Owasso apartments near O'Brien Park",
      "category": "Park",
      "h1_title": "Owasso Apartments Near O'Brien Park",
      "h2_subtitle": "Discover Owasso apartments close to O'Brien Park. Enjoy comfortable living at Cottages at Tallgrass Point with easy access to outdoor recreation.",
      "page_copy": "Cottages at Tallgrass Point offers Owasso residents the perfect location with apartments near O'Brien Park. This advantageous positioning allows you to enjoy the great outdoors while benefiting from the conveniences of modern living. Whether you're into sports, hiking, or enjoying a leisurely day at the park, our location keeps you close to all activities offered by O'Brien Park.\n\nLiving at Cottages at Tallgrass Point means enjoying features like a side-by-side refrigerator equipped with filtered water, spacious closets, and a resident clubhouse. With accessible on-site management and package receiving services, our community combines convenience with proximity to O'Brien Park, making it an excellent choice for your next home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Owasso Apartments Near O'Brien Park",
      "seo_description": "Live at Cottages at Tallgrass Point, Owasso apartments near O'Brien Park, and enjoy modern amenities with easy access to local outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167039",
      "source": "generator",
      "page_item_url": "cottages-tallgrass-point-near-oxley-nature-center",
      "search_query": "Cottages at Tallgrass Point near Oxley Nature Center",
      "category": "Park",
      "h1_title": "Cottages at Tallgrass Near Oxley Nature Center",
      "h2_subtitle": "Explore Cottages at Tallgrass Point, just a short journey from Oxley Nature Center. Enjoy nature's beauty alongside comfortable apartment living.",
      "page_copy": "Situated advantageously near the serene Oxley Nature Center, Cottages at Tallgrass Point presents an ideal blend of nature and comfort. This proximity allows residents easy access to countless outdoor activities and the tranquil ambiance of the nature center, making it a haven for nature lovers.\n\nChoose Cottages at Tallgrass Point for a comfortable lifestyle equipped with amenities like a side-by-side refrigerator with filtered water, plenty of closet space, and a welcoming resident clubhouse. Our community offers the convenience of on-site management and package receiving services, ensuring a hassle-free living experience. Embrace the natural beauty of Oxley Nature Center while enjoying everything our vibrant community has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottages at Tallgrass Near Oxley Nature Center",
      "seo_description": "Cottages at Tallgrass Point offers comfortable living near Oxley Nature Center, combining modern amenities with convenient access to nature's beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5163"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-Q10REKPSEY"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151207"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cottages-at-tallgrass-point/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PLD3RSTC"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167039/019d1bd7-bdce-770e-a783-78cd9c2f32ca.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "1e420543-b717-4963-95ff-44117734da73"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-432-0444"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64418545ed3e28f8adef65ac"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkNsdW5Ka0lxQWtoME5xVXZOVkZHN1E9PSIsInZhbHVlIjoiUUFqRkJPZmZqWWIxUTluM1hXaCtUdz09IiwibWFjIjoiMTQ3YTA5ZTUyYTg4NjZmZjNkNzViOWYxOGQzMjEzOWU5NDU2NWRkODVmYjZjNDZmMDFhOWM4MTYyNDExMzA0MyJ9"
    }
  ],
  "custom_qb_id": "5163",
  "custom_ga4_id": "G-Q10REKPSEY",
  "custom_repli_id": "10041151207",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cottages-at-tallgrass-point/register/",
  "custom_google_gtm_id": "GTM-PLD3RSTC",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167039/019d1bd7-bdce-770e-a783-78cd9c2f32ca.pdf",
  "custom_rentgrata_property_id": "1e420543-b717-4963-95ff-44117734da73",
  "custom_ppc_tracking_phone_number": "800-432-0444",
  "custom_residentboost_apartment_id": "64418545ed3e28f8adef65ac",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkNsdW5Ka0lxQWtoME5xVXZOVkZHN1E9PSIsInZhbHVlIjoiUUFqRkJPZmZqWWIxUTluM1hXaCtUdz09IiwibWFjIjoiMTQ3YTA5ZTUyYTg4NjZmZjNkNzViOWYxOGQzMjEzOWU5NDU2NWRkODVmYjZjNDZmMDFhOWM4MTYyNDExMzA0MyJ9"
};

export const generatedAt = '2026-08-27T21:33:34.201Z';
